<template>
  <div class="wrap" :class="{ 'wrap--embedded': embedded }">
    <myHead v-if="!embedded"></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu v-if="!embedded" num="1341"></ucMenu>
          <div class="right_con">
            <div class="record_main">
              <el-card shadow="never" style="min-height:650px;">
                <!-- 页面头部 -->
                <div class="page_header">
                  <span class="back_btn" @click="goBack"><i class="el-icon-arrow-left"></i> 返回</span>
                  <span class="page_title">抖店数据分析</span>
                  <div class="shop_selector">
                    <span class="filter_label">店铺：</span>
                    <el-select v-model="currentShopId" placeholder="请选择店铺" size="small" style="width:200px" filterable @change="handleShopChange">
                      <el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
                    </el-select>
                  </div>
                </div>

                <!-- 全局筛选：时间 -->
                <div class="filter_bar">
                  <div class="filter_item">
                    <span class="filter_label">时间：</span>
                    <span class="time_tag" :class="{active: timeSelectId === item.id}" v-for="item in timeOptions" :key="item.id" @click="timeTagClick(item)">{{item.name}}</span>
                    <el-date-picker
                        v-model="displayDateRange"
                        type="daterange"
                        range-separator="-"
                        size="small"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="datePickerOptions"
                        @change="customDateChange"
                        style="width:240px;margin-left:10px;">
                    </el-date-picker>
                  </div>
                </div>

                <!-- 一级标签 -->
                <div class="main_tabs">
                  <span class="main_tab" :class="{active: mainTab === 'transaction'}" @click="switchMainTab('transaction')">成交数据</span>
                  <span v-if="!isRealtimeData" class="main_tab" :class="{active: mainTab === 'refund'}" @click="switchMainTab('refund')">退款数据</span>
                </div>

                <!-- 二级标签 -->
                <div class="sub_tabs">
									<span class="sub_tab" v-for="tab in currentSubTabs" :key="tab.key"
                        :class="{active: subTab === tab.key}" @click="scrollToSection(tab.key)">
										{{tab.label}}
									</span>
                  <span class="sub_tab config-btn" v-if="subTab === '1'" @click="showFieldConfig = true">指标配置</span>
                </div>

                <!-- 数据区域 -->
                <div class="data_content" v-loading="loading" ref="dataContent">
                  <!-- 只渲染当前选中的 tab -->
                  <div :key="subTab" :ref="'section-' + subTab" :data-section-key="subTab" class="data_section">
                    <div class="section_title">{{getCurrentTabLabel()}}</div>

                    <!-- 筛选条件 -->
                    <div class="filter_bar sub_filter" v-if="getSectionFilters(subTab).length > 0 && sectionFilters[subTab]">
                      <div class="filter_item" v-if="getSectionFilters(subTab).includes('salesType')">
                        <span class="filter_label">售卖类型：</span>
                        <span class="time_tag" :class="{active: sectionFilters[subTab].salesType === opt.value}" v-for="opt in getSalesTypeOptions(subTab)" :key="opt.value" @click="sectionFilters[subTab].salesType = opt.value">{{opt.label}}</span>
                      </div>
                      <div class="filter_item" v-if="getSectionFilters(subTab).includes('carrier')">
                        <span class="filter_label">载体：</span>
                        <span class="time_tag" :class="{active: sectionFilters[subTab].carrier === opt.value}" v-for="opt in carrierOptions" :key="opt.value" @click="sectionFilters[subTab].carrier = opt.value">{{opt.label}}</span>
                      </div>
                      <div class="filter_item" v-if="getSectionFilters(subTab).includes('channelType')">
                        <span class="filter_label">渠道：</span>
                        <span class="time_tag" :class="{active: sectionFilters[subTab].channelType === opt.value}" v-for="opt in channelTypeOptions" :key="opt.value" @click="sectionFilters[subTab].channelType = opt.value">{{opt.label}}</span>
                      </div>
                      <div class="filter_item" v-if="getSectionFilters(subTab).includes('adTime')">
                        <span class="filter_label">投放时段：</span>
                        <span class="time_tag" :class="{active: sectionFilters[subTab].adTime === opt.value}" v-for="opt in adTimeOptions" :key="opt.value" @click="sectionFilters[subTab].adTime = opt.value">{{opt.label}}</span>
                      </div>
                    </div>

                    <!-- 卡片视图 -->
                    <template v-if="cardSections.includes(subTab)">
                      <div class="card_section" v-for="group in getCardGroups(subTab)" :key="group.name">
                        <div class="card_section_header">
                          <div class="card_section_title">{{group.name}}</div>
                          <!-- 退款构成的时间切换 -->
                          <div v-if="group.hasTimeSwitch" class="time_switch">
                            <el-select v-model="refundTimeType" size="small" style="width: 120px;">
                              <el-option label="支付时间" value="pay"></el-option>
                              <el-option label="退款时间" value="refund"></el-option>
                            </el-select>
                          </div>
                        </div>
                        <div class="data_cards income_expense_cards">
                          <template v-for="(field, index) in group.fields">
                            <div class="data_card income_expense_card" :key="field.key">
                              <div class="card_label">{{field.label}}</div>
                              <div class="card_value" :class="getValueClass(field, getSectionCardData(subTab)[field.key])">
                                {{formatValue(field, getSectionCardData(subTab)[field.key])}}
                              </div>
                            </div>
                            <div class="operator" v-if="field.operator && index < group.fields.length - 1" :key="'op-' + index">{{field.operator}}</div>
                          </template>
                        </div>
                      </div>
                    </template>

                    <!-- 表格视图 -->
                    <template v-else>
                      <el-table :data="getSectionTableData(subTab)" border style="width:100%;margin-top:10px;"
                                :header-cell-style="{background:'#f5f7fa',color:'#454545','font-weight':'bold','font-size':'12px'}" size="small">
                        <el-table-column v-for="col in currentTableColumns" :key="col.key"
                                         :prop="col.key" :label="col.label" :width="col.width"
                                         :min-width="col.minWidth || 100" :align="col.align || 'center'"
                                         show-overflow-tooltip>
                          <template slot-scope="scope">
										<span :class="getValueClass(col, getFieldValue(scope.row, col))">
											{{formatValue(col, getFieldValue(scope.row, col))}}
										</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot v-if="!embedded"></myFoot>

    <!-- 指标配置弹窗 -->
    <el-dialog title="指标配置" :visible.sync="showFieldConfig" width="720px" @close="onConfigClose">
      <div class="field_config_body">
        <div class="field_group" v-for="group in fieldGroups" :key="group.name">
          <div class="group_title">
            <el-checkbox :indeterminate="isGroupIndeterminate(group)" :value="isGroupAllChecked(group)" @change="toggleGroupAll(group, $event)">{{group.name}}</el-checkbox>
            <span class="group_count">{{getGroupCheckedCount(group)}} / {{group.fields.length}}</span>
          </div>
          <el-checkbox-group v-model="tempSelectedFields">
            <el-checkbox v-for="field in group.fields" :key="field.key" :label="field.key">{{field.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="showFieldConfig = false">取消</el-button>
				<el-button size="small" type="primary" @click="confirmFieldConfig">确认</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import { mapActions } from "vuex";

// 抖店指标分组定义（用于指标配置）
const douyinFieldGroups = [
  {
    name: '交易指标',
    type: 'trade',
    fields: [
      { key: 'pay_amt', label: '用户支付金额', fmt: 'money' },
      { key: 'income_amt', label: '商家实际收入', fmt: 'money' },
      { key: 'refunded_pay_amt_pay_time', label: '退后支付额 (支付时间)', fmt: 'money' },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money' },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退后券额 (支付时间)', fmt: 'money' },
      { key: 'pay_plat_cost_amt', label: '平台补贴金额', fmt: 'money' },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '退后补贴 (支付时间)', fmt: 'money' },
      { key: 'author_subsidy_amt', label: '达人补贴金额', fmt: 'money' },
      { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' },
      { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
      { key: 'pay_combo_cnt', label: '成交件数', fmt: 'num' },
      { key: 'per_pay_combo_price', label: '件单价', fmt: 'money' },
      { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
      { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
      { key: 'net_income_amt', label: '净成交金额', fmt: 'money' },
      { key: 'net_pay_cnt', label: '净成交订单量', fmt: 'num' },
    ]
  },
  {
    name: '退款指标',
    type: 'refund',
    fields: [
      { key: 'refund_amt', label: '退款金额 (退款时间)', fmt: 'money' },
      { key: 'rfndsuc_amt', label: '退款额 (退款时间)', fmt: 'money' },
      { key: 'refund_amt_pay_time', label: '退款金额 (支付时间)', fmt: 'money' },
      { key: 'rfndsuc_amt_pay_time', label: '退款额 (支付时间)', fmt: 'money' },
      { key: 'refund_amt_rate', label: '退款率 (支付时间)', fmt: 'rate' },
      { key: 'saling_refund_amt_rate_pay_time', label: '发货前退款率', fmt: 'rate' },
      { key: 'ship_refund_amt_rate_pay_time', label: '未收货退款率', fmt: 'rate' },
      { key: 'received_refund_amt_rate_pay_time', label: '已收货退款率', fmt: 'rate' },
      { key: 'received_return_good_amt_rate_pay_time', label: '已收货退货退款率', fmt: 'rate' },
      { key: 'refund_order_cnt', label: '退款订单数 (退款时间)', fmt: 'num' },
      { key: 'refund_order_cnt_pay_time', label: '退款订单数 (支付时间)', fmt: 'num' },
      { key: 'refund_amt_one_hour_pay_time', label: '1h 退款金额 (支付时间)', fmt: 'money' },
      { key: 'refund_order_cnt_one_hour_pay_time', label: '1h 退款订单数 (支付时间)', fmt: 'num' },
      { key: 'refund_amt_ratio_one_hour_pay_time', label: '1h 退款率 (支付时间)', fmt: 'rate' },
    ]
  },
  {
    name: '流量指标',
    type: 'traffic',
    fields: [
      { key: 'product_show_ucnt', label: '商品曝光人数', fmt: 'bignum' },
      { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
      { key: 'product_show_click_ucnt_ratio', label: '曝光 - 点击转化率 (人数)', fmt: 'rate' },
      { key: 'product_click_pay_ucnt_ratio', label: '点击 - 成交转化率 (人数)', fmt: 'rate' },
      { key: 'product_show_pay_ucnt_ratio', label: '曝光 - 成交转化率 (人数)', fmt: 'rate' },
      { key: 'gpm', label: '千次曝光支付金额', fmt: 'money' },
      { key: 'product_show_cnt', label: '商品曝光次数', fmt: 'bignum' },
      { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum' },
      { key: 'product_show_click_cnt_ratio', label: '曝光 - 点击转化率 (次数)', fmt: 'rate' },
      { key: 'product_click_pay_cnt_ratio', label: '点击 - 成交转化率 (次数)', fmt: 'rate' },
      { key: 'product_show_pay_cnt_ratio', label: '曝光 - 成交转化率 (次数)', fmt: 'rate' },
    ]
  },
];

// 微信小店指标分组定义（简化版）
const wechatFieldGroups = [
  {
    name: '交易指标',
    type: 'trade',
    fields: [
      { key: 'income_amt', label: '成交金额', fmt: 'money' },
      { key: 'net_pay_cnt', label: '成交订单数', fmt: 'num' },
      { key: 'net_pay_ucnt', label: '成交人数', fmt: 'num' },
      { key: 'pay_amt', label: '下单金额', fmt: 'money' },
      { key: 'pay_cnt', label: '下单订单数', fmt: 'num' },
      { key: 'pay_ucnt', label: '下单人数', fmt: 'num' },
      { key: 'per_user_price', label: '客单价', fmt: 'money' },
    ]
  },
  {
    name: '退款指标',
    type: 'refund',
    fields: [
      { key: 'refund_amt', label: '退款金额', fmt: 'money' },
      { key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money' },
      { key: 'pay_refund_success_ucnt', label: '成交退款人数', fmt: 'num' },
      { key: 'pay_refund_success_ocnt', label: '成交退款订单数', fmt: 'num' },
      { key: 'pay_refund_success_uv_rate', label: '成交退款率', fmt: 'rate' },
    ]
  },
  {
    name: '流量指标',
    type: 'traffic',
    fields: [
      { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
    ]
  }
];

// 指标分组定义（用于指标配置）- 保留用于兼容
const fieldGroups = douyinFieldGroups;

// 默认选中字段
const defaultSelectedFields = ['pay_amt', 'pay_cnt', 'pay_ucnt', 'per_usr_pay_amt', 'income_amt', 'refund_amt', 'refund_amt_rate', 'product_show_ucnt', 'product_click_ucnt', 'product_show_click_ucnt_ratio'];

// 本地存储 key
const STORAGE_KEY = 'shop_board_detail_field_config';

// 成交数据子标签
const transactionSubTabs = [
  { key: '1', label: '成交概览' },
  { key: '4', label: '收支概况' },
  { key: '5', label: '载体构成' },
  { key: '6', label: '账号构成' },
  { key: '7', label: '终端构成' },
  { key: '8', label: '品类构成' },
  { key: '9', label: '商品构成' },
  { key: '10', label: '价格带构成' },
  { key: '11', label: '人群构成' },
];
// 退款数据子标签
const refundSubTabs = [
  { key: '12', label: '退款整体数据' },
  { key: '13', label: '退款构成' },
  { key: '14', label: '退款原因' },
  { key: '15', label: '退款商品' },
];

// 卡片类型的子标签 key
const cardSections = ['1', '4'];

// 各section支持的筛选类型配置
const sectionFilterConfig = {
  '1': ['salesType', 'carrier', 'adTime'],   // 成交概览
  '4': ['salesType', 'carrier', 'adTime'],   // 收支概况
  // '5': ['salesType'],                     // 载体构成 - 不需要筛选
  '6': ['salesType'],                         // 账号构成
  '9': ['carrier'],                           // 商品构成
  '11': [],                                   // 人群构成 - 不需要筛选
  '12': ['salesType', 'carrier'],             // 退款整体数据
  '13': ['salesType', 'carrier'],             // 退款构成
  '14': ['salesType'],                        // 退款原因
  '15': ['salesType'],                        // 退款商品
};

// 需要显示筛选的子标签 key
const filterSections = Object.keys(sectionFilterConfig);

// === 卡片字段分组定义 ===
const overviewCardGroups = [
  {
    name: '交易指标',
    fields: [
      { key: 'income_amt', label: '商家实际收入', fmt: 'money' },
      { key: 'pay_amt', label: '用户支付金额', fmt: 'money' },
      { key: 'refunded_pay_amt_pay_time', label: '退后支付额(支付时间)', fmt: 'money' },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money' },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退后券额(支付时间)', fmt: 'money' },
      { key: 'pay_plat_cost_amt', label: '平台补贴金额', fmt: 'money' },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '退后补贴(支付时间)', fmt: 'money' },
      { key: 'author_subsidy_amt', label: '达人补贴金额', fmt: 'money' },
      { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' },
      { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
      { key: 'pay_combo_cnt', label: '成交件数', fmt: 'num' },
      { key: 'per_pay_combo_price', label: '件单价', fmt: 'money' },
      { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
      { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
      { key: 'net_income_amt', label: '净成交金额', fmt: 'money' },
      { key: 'net_pay_cnt', label: '净成交订单量', fmt: 'num' },
    ]
  },
  {
    name: '退款指标',
    fields: [
      { key: 'refund_amt', label: '退款金额(退款时间)', fmt: 'money' },
      { key: 'rfndsuc_amt', label: '退款额(退款时间)', fmt: 'money' },
      { key: 'refund_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money' },
      { key: 'rfndsuc_amt_pay_time', label: '退款额(支付时间)', fmt: 'money' },
      { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate' },
      { key: 'saling_refund_amt_rate_pay_time', label: '发货前退款率', fmt: 'rate' },
      { key: 'ship_refund_amt_rate_pay_time', label: '未收货退款率', fmt: 'rate' },
      { key: 'received_refund_amt_rate_pay_time', label: '已收货退款率', fmt: 'rate' },
      { key: 'received_return_good_amt_rate_pay_time', label: '已收货退货退款率', fmt: 'rate' },
      { key: 'refund_order_cnt', label: '退款订单数(退款时间)', fmt: 'num' },
      { key: 'refund_order_cnt_pay_time', label: '退款订单数(支付时间)', fmt: 'num' },
      { key: 'refund_amt_one_hour_pay_time', label: '1h退款金额(支付时间)', fmt: 'money' },
      { key: 'refund_order_cnt_one_hour_pay_time', label: '1h退款订单数(支付时间)', fmt: 'num' },
      { key: 'refund_amt_ratio_one_hour_pay_time', label: '1h退款率(支付时间)', fmt: 'rate' },
    ]
  },
  {
    name: '流量指标',
    fields: [
      { key: 'product_show_ucnt', label: '商品曝光人数', fmt: 'bignum' },
      { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
      { key: 'product_show_click_ucnt_ratio', label: '曝光-点击转化率(人数)', fmt: 'rate' },
      { key: 'product_click_pay_ucnt_ratio', label: '点击-成交转化率(人数)', fmt: 'rate' },
      { key: 'product_show_pay_ucnt_ratio', label: '曝光-成交转化率(人数)', fmt: 'rate' },
      { key: 'gpm', label: '千次曝光支付金额', fmt: 'money' },
      { key: 'product_show_cnt', label: '商品曝光次数', fmt: 'bignum' },
      { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum' },
      { key: 'product_show_click_cnt_ratio', label: '曝光-点击转化率(次数)', fmt: 'rate' },
      { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率(次数)', fmt: 'rate' },
      { key: 'product_show_pay_cnt_ratio', label: '曝光-成交转化率(次数)', fmt: 'rate' },
    ]
  }
];

// 收支概况卡片分组
const incomeExpenseCardGroups = [
  {
    name: '成交构成',
    fields: [
      { key: 'income_amt', label: '成交金额', fmt: 'money', operator: '=' },
      { key: 'pay_amt', label: '用户支付金额', fmt: 'money', operator: '+' },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money', operator: '+' },
      { key: 'pay_plat_cost_amt', label: '电商平台补贴金额', fmt: 'money', operator: '+' },
      { key: 'author_subsidy_amt', label: '达人补贴金额', fmt: 'money', operator: '-' },
      { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' },
    ]
  },
  {
    name: '退款构成',
    hasTimeSwitch: true,
    fields: [
      { key: 'refund_amt_pay_time', label: '成交退款金额', fmt: 'money', operator: '=' },
      { key: 'rfndsuc_amt_pay_time', label: '退款金额', fmt: 'money', operator: '+' },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '智能优惠券退款', fmt: 'money', operator: '+' },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '平台补贴退款', fmt: 'money', operator: '+' },
      { key: 'refund_author_subsidy_amt_pay_time', label: '达人补贴退款', fmt: 'money' },
    ],
    fieldsRefundTime: [
      { key: 'refund_amt', label: '成交退款金额', fmt: 'money', operator: '=' },
      { key: 'rfndsuc_amt', label: '退款金额', fmt: 'money', operator: '+' },
      { key: 'refund_pay_qc_plat_cost_coupon_amt_pay_time', label: '智能优惠券退款+平台补贴退款', fmt: 'money', operator: '+' },
      { key: 'refund_author_subsidy_amt_refund_time', label: '达人补贴退款', fmt: 'money' },
    ]
  },
  {
    name: '支出构成',
    fields: [
      { key: 'amount_paid', label: '支出金额', fmt: 'money', operator: '=' },
      { key: 'qc_ad_amt', label: '投放消耗', fmt: 'money', operator: '+' },
      { key: 'pt_commission_amt', label: '平台佣金(结算口径)', fmt: 'money', operator: '+' },
      { key: 'author_commission_amt', label: '达人佣金(结算口径)', fmt: 'money' },
    ]
  },
  {
    name: '其他指标',
    fields: [
      { key: 'refund_pay_ucnt_ratio_pay_time', label: '退款率(支付时间)', fmt: 'rate' },
      { key: 'qc_ad_amt_ratio_n', label: '投放费比(剔除退款)', fmt: 'rate' },
    ]
  }
];

// 载体构成卡片分组
const carrierCardGroups = [
  {
    name: '载体构成',
    fields: [
      { key: 'self_pay_amt', label: '自营用户支付金额', fmt: 'money', aggregateBy: { sales_type: '自营' } },
      { key: 'coop_pay_amt', label: '带货用户支付金额', fmt: 'money', aggregateBy: { sales_type: '带货' } },
      { key: 'live_pay_amt', label: '直播', fmt: 'money', aggregateBy: { carrier_type: '直播' } },
      { key: 'video_pay_amt', label: '短视频', fmt: 'money', aggregateBy: { carrier_type: '短视频' } },
      { key: 'graphic_pay_amt', label: '图文', fmt: 'money', aggregateBy: { carrier_type: '图文' } },
      { key: 'card_pay_amt', label: '商品卡', fmt: 'money', aggregateBy: { carrier_type: '商品卡' } },
      { key: 'other_pay_amt', label: '其他', fmt: 'money', aggregateBy: { carrier_type: '其他' } },
    ]
  }
];


// === 表格列定义 ===
const tableColumnMap = {
  // 收支概况
  '4': [
    { key: 'sales_type', label: '销售类型', width: 80, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'income_amt', label: '商家实际收入', fmt: 'money', minWidth: 110 },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' },
    { key: 'pay_qc_plat_coupon_amt', label: '优惠券金额', fmt: 'money', minWidth: 100 },
    { key: 'pay_plat_cost_amt', label: '平台补贴', fmt: 'money' },
    { key: 'author_subsidy_amt', label: '达人补贴', fmt: 'money' },
    { key: 'refund_amt_pay_time', label: '退款额(支付时间)', fmt: 'money', minWidth: 120 },
    { key: 'rfndsuc_amt_pay_time', label: '退款额(退时)', fmt: 'money', minWidth: 110 },
    { key: 'amount_paid', label: '已结金额', fmt: 'money' },
    { key: 'qc_ad_amt', label: '广告消耗', fmt: 'money' },
    { key: 'pt_commission_amt', label: '平台佣金', fmt: 'money' },
    { key: 'author_commission_amt', label: '达人佣金', fmt: 'money' },
    { key: 'refund_pay_ucnt_ratio_pay_time', label: '退款率', fmt: 'rate' },
    { key: 'qc_ad_amt_ratio_n', label: '广告占比(净)', fmt: 'rate' },
    { key: 'qc_ad_amt_ratio', label: '广告占比', fmt: 'rate' },
  ],
  // 载体构成
  '5': [
    { key: 'sales_type', label: '自营/带货', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体类型', width: 90, fmt: 'text' },
    { key: 'channel_type', label: '账号/渠道', width: 100, fmt: 'text' },
    { key: 'douyin_account', label: '抖音号', width: 130, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum', minWidth: 110 },
    { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率', fmt: 'rate', minWidth: 120 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 },
  ],
  // 账号构成
  '6': [
    { key: 'account_name', label: '账号名称', width: 130, fmt: 'text' },
    { key: 'account_type', label: '账号类型', width: 90, fmt: 'text' },
    { key: 'sales_type', label: '自营/带货', width: 90, fmt: 'text' },
    { key: 'douyin_id', label: '抖音号', width: 130, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率', fmt: 'rate', minWidth: 120 },
    { key: 'live_pay_amt', label: '直播用户支付金额', fmt: 'money', minWidth: 130 },
    { key: 'video_pay_amt', label: '短视频用户支付金额', fmt: 'money', minWidth: 140 },
    { key: 'card_pay_amt', label: '商品卡用户支付金额', fmt: 'money', minWidth: 140 },
    { key: 'other_pay_amt', label: '其他用户支付金额', fmt: 'money', minWidth: 130 },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'rfndsuc_pay_time_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 },
  ],
  // 终端构成
  '7': [
    { key: 'sales_type', label: '终端类型', width: 100, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
  ],
  // 品类构成
  '8': [
    { key: 'category_one_name', label: '一级类目', width: 100, fmt: 'text' },
    { key: 'category_two_name', label: '二级类目', width: 100, fmt: 'text' },
    { key: 'category_three_name', label: '三级类目', width: 90, fmt: 'text' },
    { key: 'category_four_name', label: '四级类目', width: 100, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 110 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
    { key: 'rfndsuc_amt_pay_time', label: '退款额', fmt: 'money' },
    { key: 'refund_amt_rate', label: '退款率', fmt: 'rate' },
  ],
  // 商品构成
  '9': [
    { key: 'product_name', label: '商品名称', width: 180, fmt: 'text', align: 'left' },
    { key: 'product_id', label: '商品ID', width: 120, fmt: 'text' },
    { key: 'product_carrier', label: '载体', width: 80, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 100 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
    { key: 'rfndsuc_amt_pay_time', label: '退款额', fmt: 'money' },
    { key: 'refund_amt_rate', label: '退款率', fmt: 'rate' },
    { key: 'pay_qc_plat_coupon_amt', label: '优惠券金额', fmt: 'money' },
    { key: 'pay_plat_cost_amt', label: '平台补贴', fmt: 'money' },
  ],
  // 价格带构成
  '10': [
    { key: 'pay_amt_interval', label: '价格区间', width: 120, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 120 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
  ],
  // 人群构成
  '11': [
    { key: 'customer_type', label: '客户类型', width: 80, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'pay_cnt', label: '订单数', fmt: 'num' },
    { key: 're_pay_rate', label: '复购率', fmt: 'rate' },
  ],
  // 退款整体数据
  '12': [
    { key: 'statistical_time', label: '日期', width: 110, fmt: 'text' },
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 80, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款阶段-退款人数', fmt: 'num', minWidth: 120 },
    { key: 'all_refund_ocnt', label: '全部退款阶段-退款订单数', fmt: 'num', minWidth: 125 },
    { key: 'all_refund_amt', label: '全部退款阶段-退款金额', fmt: 'money', minWidth: 130 },
    { key: 'all_refund_rate', label: '全部退款阶段-退款率', fmt: 'rate', minWidth: 120 },
    { key: 'ship_before_refund_ucnt', label: '发货前退款阶段-退款人数', fmt: 'num', minWidth: 135 },
    { key: 'ship_before_refund_ocnt', label: '发货前退款阶段-退款订单数', fmt: 'num', minWidth: 145 },
    { key: 'ship_before_refund_amt', label: '发货前退款阶段-退款金额', fmt: 'money', minWidth: 145 },
    { key: 'ship_before_refund_rate', label: '发货前退款阶段-退款率', fmt: 'rate', minWidth: 135 },
    { key: 'ship_after_noreceive_refund_ucnt', label: '未收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_noreceive_refund_ocnt', label: '未收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_amt', label: '未收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_rate', label: '未收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ucnt', label: '已收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ocnt', label: '已收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_amt', label: '已收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_rate', label: '已收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_refund_ucnt', label: '已收货退货退款阶段-退款人数', fmt: 'num', minWidth: 165 },
    { key: 'ship_after_receive_refund_ocnt', label: '已收货退货退款阶段-退款订单数', fmt: 'num', minWidth: 170 },
    { key: 'ship_after_receive_refund_amt', label: '已收货退货退款阶段-退款金额', fmt: 'money', minWidth: 170 },
    { key: 'ship_after_receive_refund_rate', label: '已收货退货退款阶段-退款率', fmt: 'rate', minWidth: 165 },
  ],
  // 退款构成
  '13': [
    { key: 'statistical_time', label: '日期', width: 110, fmt: 'text' },
    { key: 'refund_path', label: '退款口径', width: 90, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'douyin_id', label: '抖音号ID', width: 130, fmt: 'text' },
    { key: 'douyin_name', label: '账号名称', width: 130, fmt: 'text' },
    { key: 'all_refund_top_reason', label: '全部-TOP退款原因', width: 150, fmt: 'text' },
    { key: 'all_refund_pay_amt', label: '全部-用户支付金额', fmt: 'money', minWidth: 130 },
    { key: 'all_refund_ucnt', label: '全部-退款人数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_ocnt', label: '全部-退款订单数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_amt', label: '全部-退款金额', fmt: 'money', minWidth: 110 },
    { key: 'all_refund_rate', label: '全部-退款率', fmt: 'rate', minWidth: 100 },
    { key: 'ship_before_refund_top_reason', label: '发前-TOP退款原因', width: 150, fmt: 'text' },
    { key: 'ship_before_refund_ucnt', label: '发前-退款人数', fmt: 'num', minWidth: 110 },
    { key: 'ship_before_refund_ocnt', label: '发前-退款订单数', fmt: 'num', minWidth: 110 },
    { key: 'ship_before_refund_amt', label: '发前-退款金额', fmt: 'money', minWidth: 110 },
    { key: 'ship_before_refund_rate', label: '发前-退款率', fmt: 'rate', minWidth: 100 },
    { key: 'ship_after_receive_b_top_reason', label: '未收-TOP退款原因', width: 150, fmt: 'text' },
    { key: 'ship_after_noreceive_refund_ucnt', label: '未收-退款人数', fmt: 'num', minWidth: 110 },
    { key: 'ship_after_noreceive_refund_ocnt', label: '未收-退款订单数', fmt: 'num', minWidth: 110 },
    { key: 'ship_after_noreceive_refund_amt', label: '未收-退款金额', fmt: 'money', minWidth: 110 },
    { key: 'ship_after_noreceive_refund_rate', label: '未收-退款率', fmt: 'rate', minWidth: 100 },
    { key: 'ship_after_receive_b_top_reason', label: '已收-TOP退款原因', width: 150, fmt: 'text' },
    { key: 'ship_after_receive_b_refund_ucnt', label: '已收-退款人数', fmt: 'num', minWidth: 110 },
    { key: 'ship_after_receive_b_refund_ocnt', label: '已收-退款订单数', fmt: 'num', minWidth: 110 },
    { key: 'ship_after_receive_b_refund_amt', label: '已收-退款金额', fmt: 'money', minWidth: 110 },
    { key: 'ship_after_receive_b_refund_rate', label: '已收-退款率', fmt: 'rate', minWidth: 100 },
    { key: 'ship_after_receive_top_reason', label: '已收退货-TOP退款原因', width: 170, fmt: 'text' },
    { key: 'ship_after_receive_refund_ucnt', label: '已收退货-退款人数', fmt: 'num', minWidth: 130 },
    { key: 'ship_after_receive_refund_ocnt', label: '已收退货-退款订单数', fmt: 'num', minWidth: 140 },
    { key: 'ship_after_receive_refund_amt', label: '已收退货-退款金额', fmt: 'money', minWidth: 130 },
    { key: 'ship_after_receive_refund_rate', label: '已收退货-退款率', fmt: 'rate', minWidth: 120 },
  ],
  // 退款原因
  '14': [
    { key: 'statistical_time', label: '日期', width: 110, fmt: 'text' },
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 80, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'cause_type', label: '原因分类', width: 90, fmt: 'text' },
    { key: 'cause_msg', label: '具体原因', width: 150, fmt: 'text', align: 'left' },
    { key: 'all_refund_ucnt', label: '全部退款阶段-退款人数', fmt: 'num', minWidth: 120 },
    { key: 'all_refund_ocnt', label: '全部退款阶段-退款订单数', fmt: 'num', minWidth: 125 },
    { key: 'all_refund_amt', label: '全部退款阶段-退款金额', fmt: 'money', minWidth: 130 },
    { key: 'all_refund_rate', label: '全部退款阶段-退款率', fmt: 'rate', minWidth: 120 },
    { key: 'ship_before_refund_ucnt', label: '发货前退款阶段-退款人数', fmt: 'num', minWidth: 135 },
    { key: 'ship_before_refund_ocnt', label: '发货前退款阶段-退款订单数', fmt: 'num', minWidth: 145 },
    { key: 'ship_before_refund_amt', label: '发货前退款阶段-退款金额', fmt: 'money', minWidth: 145 },
    { key: 'ship_before_refund_rate', label: '发货前退款阶段-退款率', fmt: 'rate', minWidth: 135 },
    { key: 'ship_after_noreceive_refund_ucnt', label: '未收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_noreceive_refund_ocnt', label: '未收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_amt', label: '未收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_rate', label: '未收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ucnt', label: '已收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ocnt', label: '已收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_amt', label: '已收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_rate', label: '已收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_refund_ucnt', label: '已收货退货退款阶段-退款人数', fmt: 'num', minWidth: 165 },
    { key: 'ship_after_receive_refund_ocnt', label: '已收货退货退款阶段-退款订单数', fmt: 'num', minWidth: 170 },
    { key: 'ship_after_receive_refund_amt', label: '已收货退货退款阶段-退款金额', fmt: 'money', minWidth: 170 },
    { key: 'ship_after_receive_refund_rate', label: '已收货退货退款阶段-退款率', fmt: 'rate', minWidth: 165 },
  ],
  // 退款商品
  '15': [
    { key: 'statistical_time', label: '日期', width: 110, fmt: 'text' },
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'product_name', label: '商品名称', width: 180, fmt: 'text', align: 'left' },
    { key: 'product_id', label: '商品ID', width: 120, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 80, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 80, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款阶段-退款人数', fmt: 'num', minWidth: 120 },
    { key: 'all_refund_ocnt', label: '全部退款阶段-退款订单数', fmt: 'num', minWidth: 125 },
    { key: 'all_refund_amt', label: '全部退款阶段-退款金额', fmt: 'money', minWidth: 130 },
    { key: 'all_refund_rate', label: '全部退款阶段-退款率', fmt: 'rate', minWidth: 120 },
    { key: 'all_refund_upay_amt', label: '全部退款阶段-用户支付金额', fmt: 'money', minWidth: 145 },
    { key: 'all_refund_orer_cnt', label: '全部退款阶段-支付订单数', fmt: 'num', minWidth: 145 },
    { key: 'ship_before_refund_ucnt', label: '发货前退款阶段-退款人数', fmt: 'num', minWidth: 135 },
    { key: 'ship_before_refund_ocnt', label: '发货前退款阶段-退款订单数', fmt: 'num', minWidth: 145 },
    { key: 'ship_before_refund_amt', label: '发货前退款阶段-退款金额', fmt: 'money', minWidth: 145 },
    { key: 'ship_before_refund_rate', label: '发货前退款阶段-退款率', fmt: 'rate', minWidth: 135 },
    { key: 'ship_after_noreceive_refund_ucnt', label: '未收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_noreceive_refund_ocnt', label: '未收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_amt', label: '未收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_noreceive_refund_rate', label: '未收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ucnt', label: '已收货退款阶段-退款人数', fmt: 'num', minWidth: 145 },
    { key: 'ship_after_receive_b_refund_ocnt', label: '已收货退款阶段-退款订单数', fmt: 'num', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_amt', label: '已收货退款阶段-退款金额', fmt: 'money', minWidth: 150 },
    { key: 'ship_after_receive_b_refund_rate', label: '已收货退款阶段-退款率', fmt: 'rate', minWidth: 145 },
    { key: 'ship_after_receive_refund_ucnt', label: '已收货退货退款阶段-退款人数', fmt: 'num', minWidth: 165 },
    { key: 'ship_after_receive_refund_ocnt', label: '已收货退货退款阶段-退款订单数', fmt: 'num', minWidth: 170 },
    { key: 'ship_after_receive_refund_amt', label: '已收货退货退款阶段-退款金额', fmt: 'money', minWidth: 170 },
    { key: 'ship_after_receive_refund_rate', label: '已收货退货退款阶段-退款率', fmt: 'rate', minWidth: 165 },
  ],
};

// Mock数据 - 已改用真实接口
/*
const mockApiData = {
	transaction_data: {
		"1": {
			_label: "成交概览",
			data: [
				{ statistical_time: "2026-02-20", carrier_type: "短视频", qc_ad_time: "全天", income_amt: 128560.50, pay_amt: 135280.00, refunded_pay_amt_pay_time: 121450.30, pay_qc_plat_coupon_amt: 3200.00, refund_pay_qc_plat_coupon_amt_pay_time: 280.50, pay_plat_cost_amt: 1500.00, refund_pay_plat_cost_amt_pay_time: 120.00, author_subsidy_amt: 800.00, deposit_pay_amt: 2500.00, pay_cnt: 856, pay_combo_cnt: 1230, per_pay_combo_price: 109.98, pay_ucnt: 720, per_usr_pay_amt: 187.89, net_income_amt: 115320.80, net_pay_cnt: 790, refund_amt: 13239.70, rfndsuc_amt: 12580.00, refund_amt_pay_time: 11200.50, rfndsuc_amt_pay_time: 10850.00, refund_amt_rate: 8.03, saling_refund_amt_rate_pay_time: 3.20, ship_refund_amt_rate_pay_time: 2.10, received_refund_amt_rate_pay_time: 1.80, received_return_good_amt_rate_pay_time: 0.93, refund_order_cnt: 66, refund_order_cnt_pay_time: 58, refund_amt_one_hour_pay_time: 3200.00, refund_order_cnt_one_hour_pay_time: 15, refund_amt_ratio_one_hour_pay_time: 2.37, product_show_ucnt: 352000, product_click_ucnt: 28500, product_show_click_ucnt_ratio: 8.10, product_click_pay_ucnt_ratio: 2.53, product_show_pay_ucnt_ratio: 0.20, gpm: 384.32, product_show_cnt: 1580000, product_click_cnt: 95000, product_show_click_cnt_ratio: 6.01, product_click_pay_cnt_ratio: 0.90, product_show_pay_cnt_ratio: 0.054 },
				{ statistical_time: "2026-02-20", carrier_type: "直播", qc_ad_time: "全天", income_amt: 86230.00, pay_amt: 92100.50, refunded_pay_amt_pay_time: 82500.00, pay_qc_plat_coupon_amt: 1800.00, refund_pay_qc_plat_coupon_amt_pay_time: 150.00, pay_plat_cost_amt: 900.00, refund_pay_plat_cost_amt_pay_time: 80.00, author_subsidy_amt: 500.00, deposit_pay_amt: 1200.00, pay_cnt: 520, pay_combo_cnt: 780, per_pay_combo_price: 118.08, pay_ucnt: 430, per_usr_pay_amt: 214.19, net_income_amt: 76800.00, net_pay_cnt: 478, refund_amt: 9430.00, rfndsuc_amt: 8900.50, refund_amt_pay_time: 8200.00, rfndsuc_amt_pay_time: 7800.00, refund_amt_rate: 8.47, saling_refund_amt_rate_pay_time: 2.80, ship_refund_amt_rate_pay_time: 2.50, received_refund_amt_rate_pay_time: 2.00, received_return_good_amt_rate_pay_time: 1.17, refund_order_cnt: 42, refund_order_cnt_pay_time: 36, refund_amt_one_hour_pay_time: 2100.00, refund_order_cnt_one_hour_pay_time: 10, refund_amt_ratio_one_hour_pay_time: 2.28, product_show_ucnt: 185000, product_click_ucnt: 16200, product_show_click_ucnt_ratio: 8.76, product_click_pay_ucnt_ratio: 2.65, product_show_pay_ucnt_ratio: 0.23, gpm: 497.84, product_show_cnt: 920000, product_click_cnt: 62000, product_show_click_cnt_ratio: 6.74, product_click_pay_cnt_ratio: 0.84, product_show_pay_cnt_ratio: 0.057 },
				{ statistical_time: "2026-02-20", carrier_type: "商品卡", qc_ad_time: "全天", income_amt: 23680.00, pay_amt: 25100.00, refunded_pay_amt_pay_time: 22800.00, pay_qc_plat_coupon_amt: 600.00, refund_pay_qc_plat_coupon_amt_pay_time: 50.00, pay_plat_cost_amt: 300.00, refund_pay_plat_cost_amt_pay_time: 20.00, author_subsidy_amt: 0, deposit_pay_amt: 400.00, pay_cnt: 180, pay_combo_cnt: 210, per_pay_combo_price: 119.52, pay_ucnt: 165, per_usr_pay_amt: 152.12, net_income_amt: 21500.00, net_pay_cnt: 168, refund_amt: 2180.00, rfndsuc_amt: 2050.00, refund_amt_pay_time: 1900.00, rfndsuc_amt_pay_time: 1800.00, refund_amt_rate: 7.17, saling_refund_amt_rate_pay_time: 2.50, ship_refund_amt_rate_pay_time: 1.80, received_refund_amt_rate_pay_time: 1.50, received_return_good_amt_rate_pay_time: 1.37, refund_order_cnt: 12, refund_order_cnt_pay_time: 10, refund_amt_one_hour_pay_time: 600.00, refund_order_cnt_one_hour_pay_time: 3, refund_amt_ratio_one_hour_pay_time: 2.39, product_show_ucnt: 98000, product_click_ucnt: 5600, product_show_click_ucnt_ratio: 5.71, product_click_pay_ucnt_ratio: 2.95, product_show_pay_ucnt_ratio: 0.17, gpm: 256.12, product_show_cnt: 450000, product_click_cnt: 18000, product_show_click_cnt_ratio: 4.00, product_click_pay_cnt_ratio: 1.00, product_show_pay_cnt_ratio: 0.04 }
			]
		},
		"2": {
			_label: "自营成交",
			data: [
				{ statistical_time: "2026-02-20", carrier_type: "短视频", qc_ad_time: "全天", income_amt: 98500.00, pay_amt: 105200.00, refunded_pay_amt_pay_time: 95800.00, pay_qc_plat_coupon_amt: 2800.00, refund_pay_qc_plat_coupon_amt_pay_time: 220.00, pay_plat_cost_amt: 1200.00, refund_pay_plat_cost_amt_pay_time: 95.00, author_subsidy_amt: 0, deposit_pay_amt: 1800.00, pay_cnt: 650, pay_combo_cnt: 920, per_pay_combo_price: 114.35, pay_ucnt: 540, per_usr_pay_amt: 194.81, net_income_amt: 88200.00, net_pay_cnt: 600, refund_amt: 10300.00, rfndsuc_amt: 9800.00, refund_amt_pay_time: 8500.00, rfndsuc_amt_pay_time: 8100.00, refund_amt_rate: 7.70, saling_refund_amt_rate_pay_time: 2.90, ship_refund_amt_rate_pay_time: 2.30, received_refund_amt_rate_pay_time: 1.60, received_return_good_amt_rate_pay_time: 0.90, refund_order_cnt: 50, refund_order_cnt_pay_time: 42, refund_amt_one_hour_pay_time: 2500.00, refund_order_cnt_one_hour_pay_time: 12, refund_amt_ratio_one_hour_pay_time: 2.38, product_show_ucnt: 280000, product_click_ucnt: 22000, product_show_click_ucnt_ratio: 7.86, product_click_pay_ucnt_ratio: 2.45, product_show_pay_ucnt_ratio: 0.19, gpm: 375.71, product_show_cnt: 1200000, product_click_cnt: 72000, product_show_click_cnt_ratio: 6.00, product_click_pay_cnt_ratio: 0.90, product_show_pay_cnt_ratio: 0.054 },
				{ statistical_time: "2026-02-20", carrier_type: "直播", qc_ad_time: "全天", income_amt: 62800.00, pay_amt: 68500.00, refunded_pay_amt_pay_time: 61200.00, pay_qc_plat_coupon_amt: 1500.00, refund_pay_qc_plat_coupon_amt_pay_time: 120.00, pay_plat_cost_amt: 700.00, refund_pay_plat_cost_amt_pay_time: 55.00, author_subsidy_amt: 0, deposit_pay_amt: 900.00, pay_cnt: 380, pay_combo_cnt: 560, per_pay_combo_price: 122.32, pay_ucnt: 310, per_usr_pay_amt: 220.97, net_income_amt: 56000.00, net_pay_cnt: 348, refund_amt: 6800.00, rfndsuc_amt: 6500.00, refund_amt_pay_time: 5800.00, rfndsuc_amt_pay_time: 5500.00, refund_amt_rate: 8.03, saling_refund_amt_rate_pay_time: 3.10, ship_refund_amt_rate_pay_time: 2.40, received_refund_amt_rate_pay_time: 1.70, received_return_good_amt_rate_pay_time: 0.83, refund_order_cnt: 32, refund_order_cnt_pay_time: 28, refund_amt_one_hour_pay_time: 1600.00, refund_order_cnt_one_hour_pay_time: 8, refund_amt_ratio_one_hour_pay_time: 2.34, product_show_ucnt: 150000, product_click_ucnt: 12800, product_show_click_ucnt_ratio: 8.53, product_click_pay_ucnt_ratio: 2.42, product_show_pay_ucnt_ratio: 0.21, gpm: 456.67, product_show_cnt: 720000, product_click_cnt: 48000, product_show_click_cnt_ratio: 6.67, product_click_pay_cnt_ratio: 0.79, product_show_pay_cnt_ratio: 0.053 }
			]
		},
		"3": {
			_label: "合作成交",
			data: [
				{ statistical_time: "2026-02-20", carrier_type: "短视频", qc_ad_time: "全天", income_amt: 30060.50, pay_amt: 30080.00, refunded_pay_amt_pay_time: 25650.30, pay_qc_plat_coupon_amt: 400.00, refund_pay_qc_plat_coupon_amt_pay_time: 60.50, pay_plat_cost_amt: 300.00, refund_pay_plat_cost_amt_pay_time: 25.00, author_subsidy_amt: 800.00, deposit_pay_amt: 700.00, pay_cnt: 206, pay_combo_cnt: 310, per_pay_combo_price: 97.03, pay_ucnt: 180, per_usr_pay_amt: 167.11, net_income_amt: 27120.80, net_pay_cnt: 190, refund_amt: 2939.70, rfndsuc_amt: 2780.00, refund_amt_pay_time: 2700.50, rfndsuc_amt_pay_time: 2550.00, refund_amt_rate: 8.47, saling_refund_amt_rate_pay_time: 3.50, ship_refund_amt_rate_pay_time: 2.20, received_refund_amt_rate_pay_time: 1.90, received_return_good_amt_rate_pay_time: 0.87, refund_order_cnt: 16, refund_order_cnt_pay_time: 14, refund_amt_one_hour_pay_time: 700.00, refund_order_cnt_one_hour_pay_time: 3, refund_amt_ratio_one_hour_pay_time: 2.33, product_show_ucnt: 72000, product_click_ucnt: 6500, product_show_click_ucnt_ratio: 9.03, product_click_pay_ucnt_ratio: 2.77, product_show_pay_ucnt_ratio: 0.25, gpm: 417.51, product_show_cnt: 380000, product_click_cnt: 23000, product_show_click_cnt_ratio: 6.05, product_click_pay_cnt_ratio: 0.90, product_show_pay_cnt_ratio: 0.054 }
			]
		},
		"4": {
			_label: "收支概况",
			data: [
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "短视频", qc_ad_time: "全天", income_amt: 98500.00, pay_amt: 105200.00, deposit_pay_amt: 1800.00, pay_qc_plat_coupon_amt: 2800.00, pay_plat_cost_amt: 1200.00, author_subsidy_amt: 0, refund_amt_pay_time: 8500.00, rfndsuc_amt_pay_time: 8100.00, refund_pay_qc_plat_coupon_amt_pay_time: 220.00, refund_pay_plat_cost_amt_pay_time: 95.00, refund_author_subsidy_amt_pay_time: 0, refund_amt: 10300.00, rfndsuc_amt: 9800.00, refund_pay_qc_plat_cost_coupon_amt_pay_time: 315.00, refund_author_subsidy_amt_refund_time: 0, amount_paid: 28500.00, qc_ad_amt: 18600.00, pt_commission_amt: 5200.00, author_commission_amt: 0, refund_pay_ucnt_ratio_pay_time: 7.70, qc_ad_amt_ratio_n: 19.43, qc_ad_amt_ratio: 17.68 },
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "直播", qc_ad_time: "全天", income_amt: 62800.00, pay_amt: 68500.00, deposit_pay_amt: 900.00, pay_qc_plat_coupon_amt: 1500.00, pay_plat_cost_amt: 700.00, author_subsidy_amt: 0, refund_amt_pay_time: 5800.00, rfndsuc_amt_pay_time: 5500.00, refund_pay_qc_plat_coupon_amt_pay_time: 120.00, refund_pay_plat_cost_amt_pay_time: 55.00, refund_author_subsidy_amt_pay_time: 0, refund_amt: 6800.00, rfndsuc_amt: 6500.00, refund_pay_qc_plat_cost_coupon_amt_pay_time: 175.00, refund_author_subsidy_amt_refund_time: 0, amount_paid: 16800.00, qc_ad_amt: 12000.00, pt_commission_amt: 3150.00, author_commission_amt: 0, refund_pay_ucnt_ratio_pay_time: 8.03, qc_ad_amt_ratio_n: 19.61, qc_ad_amt_ratio: 17.52 },
				{ statistical_time: "2026-02-20", sales_type: "合作", carrier_type: "短视频", qc_ad_time: "全天", income_amt: 30060.50, pay_amt: 30080.00, deposit_pay_amt: 700.00, pay_qc_plat_coupon_amt: 400.00, pay_plat_cost_amt: 300.00, author_subsidy_amt: 800.00, refund_amt_pay_time: 2700.50, rfndsuc_amt_pay_time: 2550.00, refund_pay_qc_plat_coupon_amt_pay_time: 60.50, refund_pay_plat_cost_amt_pay_time: 25.00, refund_author_subsidy_amt_pay_time: 72.00, refund_amt: 2939.70, rfndsuc_amt: 2780.00, refund_pay_qc_plat_cost_coupon_amt_pay_time: 85.50, refund_author_subsidy_amt_refund_time: 80.00, amount_paid: 12500.00, qc_ad_amt: 5800.00, pt_commission_amt: 1500.00, author_commission_amt: 4200.00, refund_pay_ucnt_ratio_pay_time: 8.47, qc_ad_amt_ratio_n: 21.12, qc_ad_amt_ratio: 19.28 }
			]
		},
		"5": {
			_label: "载体构成",
			data: [
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "短视频", channel_type: "抖音号", douyin_account: "好物推荐官", pay_amt: 68500.00, pay_cnt: 420, pay_ucnt: 350, product_click_cnt: 48000, product_click_pay_cnt_ratio: 0.88, per_usr_pay_amt: 195.71, rfndsuc_amt_pay_time: 5200.00, refund_amt_rate: 7.59 },
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "短视频", channel_type: "抖音号", douyin_account: "生活好物馆", pay_amt: 36700.00, pay_cnt: 230, pay_ucnt: 190, product_click_cnt: 24000, product_click_pay_cnt_ratio: 0.96, per_usr_pay_amt: 193.16, rfndsuc_amt_pay_time: 2900.00, refund_amt_rate: 7.90 },
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "直播", channel_type: "抖音号", douyin_account: "好物推荐官", pay_amt: 42300.00, pay_cnt: 250, pay_ucnt: 200, product_click_cnt: 32000, product_click_pay_cnt_ratio: 0.78, per_usr_pay_amt: 211.50, rfndsuc_amt_pay_time: 3500.00, refund_amt_rate: 8.27 },
				{ statistical_time: "2026-02-20", sales_type: "自营", carrier_type: "商品卡", channel_type: "自然流量", douyin_account: "-", pay_amt: 25100.00, pay_cnt: 180, pay_ucnt: 165, product_click_cnt: 18000, product_click_pay_cnt_ratio: 1.00, per_usr_pay_amt: 152.12, rfndsuc_amt_pay_time: 1800.00, refund_amt_rate: 7.17 }
			]
		},
		"7": {
			_label: "终端构成",
			data: [
				{ statistical_time: "2026-02-20", sales_type: "Android", pay_amt: 142800.00, pay_ucnt: 760, per_usr_pay_amt: 187.89, product_click_pay_cnt_ratio: 0.92 },
				{ statistical_time: "2026-02-20", sales_type: "iOS", pay_amt: 86200.00, pay_ucnt: 420, per_usr_pay_amt: 205.24, product_click_pay_cnt_ratio: 0.85 },
				{ statistical_time: "2026-02-20", sales_type: "其他", pay_amt: 3480.50, pay_ucnt: 35, per_usr_pay_amt: 99.44, product_click_pay_cnt_ratio: 0.62 }
			]
		},
		"8": {
			_label: "品类构成",
			data: [
				{ statistical_time: "2026-02-20", category_one_name: "家居日用", category_two_name: "厨房用品", category_three_name: "杯壶", category_four_name: "陶瓷杯", pay_amt: 85600.00, per_usr_pay_amt: 168.50, product_click_pay_cnt_ratio: 0.95, rfndsuc_amt_pay_time: 6200.00, refund_amt_rate: 7.24 },
				{ statistical_time: "2026-02-20", category_one_name: "家居日用", category_two_name: "厨房用品", category_three_name: "餐具", category_four_name: "碗碟套装", pay_amt: 62300.00, per_usr_pay_amt: 198.40, product_click_pay_cnt_ratio: 0.82, rfndsuc_amt_pay_time: 5100.00, refund_amt_rate: 8.19 },
				{ statistical_time: "2026-02-20", category_one_name: "家居日用", category_two_name: "收纳整理", category_three_name: "收纳箱", category_four_name: "塑料收纳箱", pay_amt: 42500.00, per_usr_pay_amt: 125.00, product_click_pay_cnt_ratio: 1.10, rfndsuc_amt_pay_time: 3200.00, refund_amt_rate: 7.53 },
				{ statistical_time: "2026-02-20", category_one_name: "服饰内衣", category_two_name: "女装", category_three_name: "连衣裙", category_four_name: "碎花连衣裙", pay_amt: 42080.50, per_usr_pay_amt: 256.80, product_click_pay_cnt_ratio: 0.68, rfndsuc_amt_pay_time: 4350.00, refund_amt_rate: 10.34 }
			]
		},
		"9": {
			_label: "商品构成",
			data: [
				{ statistical_time: "2026-02-20", product_name: "手工陶瓷茶杯 复古风 大容量马克杯", product_id: "3777821152630669901", product_carrier: "短视频", pay_amt: 45600.00, per_usr_pay_amt: 152.00, product_click_pay_cnt_ratio: 1.05, rfndsuc_amt_pay_time: 3200.00, refund_amt_rate: 7.02, pay_qc_plat_coupon_amt: 1200.00, pay_plat_cost_amt: 500.00, refund_pay_qc_plat_coupon_amt_pay_time: 85.00, refund_pay_plat_cost_amt_pay_time: 35.00 },
				{ statistical_time: "2026-02-20", product_name: "日式简约陶瓷碗碟套装 家用餐具", product_id: "3777821152630669902", product_carrier: "直播", pay_amt: 38200.00, per_usr_pay_amt: 218.29, product_click_pay_cnt_ratio: 0.78, rfndsuc_amt_pay_time: 3600.00, refund_amt_rate: 9.42, pay_qc_plat_coupon_amt: 800.00, pay_plat_cost_amt: 350.00, refund_pay_qc_plat_coupon_amt_pay_time: 72.00, refund_pay_plat_cost_amt_pay_time: 30.00 },
				{ statistical_time: "2026-02-20", product_name: "创意手绘花瓶 客厅装饰摆件", product_id: "3777821152630669903", product_carrier: "短视频", pay_amt: 28500.00, per_usr_pay_amt: 285.00, product_click_pay_cnt_ratio: 0.62, rfndsuc_amt_pay_time: 2800.00, refund_amt_rate: 9.82, pay_qc_plat_coupon_amt: 600.00, pay_plat_cost_amt: 250.00, refund_pay_qc_plat_coupon_amt_pay_time: 55.00, refund_pay_plat_cost_amt_pay_time: 20.00 },
				{ statistical_time: "2026-02-20", product_name: "多功能塑料收纳箱 大号带盖", product_id: "3777821152630669904", product_carrier: "商品卡", pay_amt: 22800.00, per_usr_pay_amt: 76.00, product_click_pay_cnt_ratio: 1.32, rfndsuc_amt_pay_time: 1500.00, refund_amt_rate: 6.58, pay_qc_plat_coupon_amt: 400.00, pay_plat_cost_amt: 180.00, refund_pay_qc_plat_coupon_amt_pay_time: 28.00, refund_pay_plat_cost_amt_pay_time: 12.00 }
			]
		},
		"10": {
			_label: "价格带构成",
			data: [
				{ statistical_time: "2026-02-20", pay_amt_interval: "0-50元", pay_amt: 18500.00, per_usr_pay_amt: 32.50, product_click_pay_cnt_ratio: 1.85 },
				{ statistical_time: "2026-02-20", pay_amt_interval: "50-100元", pay_amt: 45600.00, per_usr_pay_amt: 78.20, product_click_pay_cnt_ratio: 1.20 },
				{ statistical_time: "2026-02-20", pay_amt_interval: "100-200元", pay_amt: 82300.00, per_usr_pay_amt: 156.80, product_click_pay_cnt_ratio: 0.85 },
				{ statistical_time: "2026-02-20", pay_amt_interval: "200-500元", pay_amt: 65200.00, per_usr_pay_amt: 328.50, product_click_pay_cnt_ratio: 0.52 },
				{ statistical_time: "2026-02-20", pay_amt_interval: "500元以上", pay_amt: 20880.50, per_usr_pay_amt: 680.00, product_click_pay_cnt_ratio: 0.28 }
			]
		},
		"11": {
			_label: "人群构成",
			data: [
				{ statistical_time: "2026-02-20", customer_type: "新客", carrier_type: "短视频", pay_amt: 78500.00, pay_ucnt: 480, per_usr_pay_amt: 163.54, pay_cnt: 520, re_pay_rate: 0 },
				{ statistical_time: "2026-02-20", customer_type: "老客", carrier_type: "短视频", pay_amt: 56780.00, pay_ucnt: 240, per_usr_pay_amt: 236.58, pay_cnt: 336, re_pay_rate: 32.50 },
				{ statistical_time: "2026-02-20", customer_type: "新客", carrier_type: "直播", pay_amt: 52100.00, pay_ucnt: 280, per_usr_pay_amt: 186.07, pay_cnt: 320, re_pay_rate: 0 },
				{ statistical_time: "2026-02-20", customer_type: "老客", carrier_type: "直播", pay_amt: 40000.50, pay_ucnt: 150, per_usr_pay_amt: 266.67, pay_cnt: 200, re_pay_rate: 28.00 },
				{ statistical_time: "2026-02-20", customer_type: "新客", carrier_type: "商品卡", pay_amt: 15200.00, pay_ucnt: 120, per_usr_pay_amt: 126.67, pay_cnt: 130, re_pay_rate: 0 },
				{ statistical_time: "2026-02-20", customer_type: "老客", carrier_type: "商品卡", pay_amt: 9900.00, pay_ucnt: 45, per_usr_pay_amt: 220.00, pay_cnt: 50, re_pay_rate: 35.00 }
			]
		}
	},
	refund_data: {
		"12": {
			_label: "退款整体数据",
			data: [
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "自营", carrier_type: "全部", all_refund_ucnt: 108, all_refund_ocnt: 132, all_refund_amt: 18849.70, all_refund_rate: 8.12, ship_before_refund_ucnt: 35, ship_before_refund_ocnt: 42, ship_before_refund_amt: 5680.00, ship_before_refund_rate: 2.45, ship_after_noreceive_refund_ucnt: 28, ship_after_noreceive_refund_ocnt: 35, ship_after_noreceive_refund_amt: 4920.00, ship_after_noreceive_refund_rate: 2.12, ship_after_receive_b_refund_ocnt: 30, ship_after_receive_b_refund_amt: 4580.50, ship_after_receive_b_refund_rate: 1.97, ship_after_receive_refund_ucnt: 20, ship_after_receive_refund_ocnt: 25, ship_after_receive_refund_amt: 3669.20, ship_after_receive_refund_rate: 1.58 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "合作", carrier_type: "全部", all_refund_ucnt: 22, all_refund_ocnt: 28, all_refund_amt: 3780.00, all_refund_rate: 9.15, ship_before_refund_ucnt: 8, ship_before_refund_ocnt: 10, ship_before_refund_amt: 1280.00, ship_before_refund_rate: 3.10, ship_after_noreceive_refund_ucnt: 6, ship_after_noreceive_refund_ocnt: 8, ship_after_noreceive_refund_amt: 980.00, ship_after_noreceive_refund_rate: 2.37, ship_after_receive_b_refund_ocnt: 5, ship_after_receive_b_refund_amt: 820.00, ship_after_receive_b_refund_rate: 1.98, ship_after_receive_refund_ucnt: 4, ship_after_receive_refund_ocnt: 5, ship_after_receive_refund_amt: 700.00, ship_after_receive_refund_rate: 1.70 }
			]
		},
		"14": {
			_label: "退款原因",
			data: [
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "自营", carrier_type: "全部", cause_type: "商品问题", cause_msg: "商品与描述不符", all_refund_ucnt: 25, all_refund_ocnt: 30, all_refund_amt: 4500.00, all_refund_rate: 1.94, ship_before_refund_ucnt: 0, ship_before_refund_ocnt: 0, ship_before_refund_amt: 0, ship_before_refund_rate: 0, ship_after_noreceive_refund_ucnt: 0, ship_after_noreceive_refund_ocnt: 0, ship_after_noreceive_refund_amt: 0, ship_after_noreceive_refund_rate: 0, ship_after_receive_b_refund_ocnt: 15, ship_after_receive_b_refund_amt: 2500.00, ship_after_receive_b_refund_rate: 1.08, ship_after_receive_refund_ucnt: 12, ship_after_receive_refund_ocnt: 15, ship_after_receive_refund_amt: 2000.00, ship_after_receive_refund_rate: 0.86 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "自营", carrier_type: "全部", cause_type: "商品问题", cause_msg: "质量问题", all_refund_ucnt: 18, all_refund_ocnt: 22, all_refund_amt: 3200.00, all_refund_rate: 1.38, ship_before_refund_ucnt: 0, ship_before_refund_ocnt: 0, ship_before_refund_amt: 0, ship_before_refund_rate: 0, ship_after_noreceive_refund_ucnt: 0, ship_after_noreceive_refund_ocnt: 0, ship_after_noreceive_refund_amt: 0, ship_after_noreceive_refund_rate: 0, ship_after_receive_b_refund_ocnt: 12, ship_after_receive_b_refund_amt: 1800.00, ship_after_receive_b_refund_rate: 0.78, ship_after_receive_refund_ucnt: 8, ship_after_receive_refund_ocnt: 10, ship_after_receive_refund_amt: 1400.00, ship_after_receive_refund_rate: 0.60 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "自营", carrier_type: "全部", cause_type: "个人原因", cause_msg: "不想要了/多拍", all_refund_ucnt: 32, all_refund_ocnt: 38, all_refund_amt: 5200.00, all_refund_rate: 2.24, ship_before_refund_ucnt: 28, ship_before_refund_ocnt: 32, ship_before_refund_amt: 4500.00, ship_before_refund_rate: 1.94, ship_after_noreceive_refund_ucnt: 3, ship_after_noreceive_refund_ocnt: 4, ship_after_noreceive_refund_amt: 500.00, ship_after_noreceive_refund_rate: 0.22, ship_after_receive_b_refund_ocnt: 2, ship_after_receive_b_refund_amt: 200.00, ship_after_receive_b_refund_rate: 0.09, ship_after_receive_refund_ucnt: 0, ship_after_receive_refund_ocnt: 0, ship_after_receive_refund_amt: 0, ship_after_receive_refund_rate: 0 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", sales_type: "自营", carrier_type: "全部", cause_type: "物流问题", cause_msg: "快递一直未送达", all_refund_ucnt: 15, all_refund_ocnt: 18, all_refund_amt: 2800.00, all_refund_rate: 1.21, ship_before_refund_ucnt: 0, ship_before_refund_ocnt: 0, ship_before_refund_amt: 0, ship_before_refund_rate: 0, ship_after_noreceive_refund_ucnt: 15, ship_after_noreceive_refund_ocnt: 18, ship_after_noreceive_refund_amt: 2800.00, ship_after_noreceive_refund_rate: 1.21, ship_after_receive_b_refund_ocnt: 0, ship_after_receive_b_refund_amt: 0, ship_after_receive_b_refund_rate: 0, ship_after_receive_refund_ucnt: 0, ship_after_receive_refund_ocnt: 0, ship_after_receive_refund_amt: 0, ship_after_receive_refund_rate: 0 }
			]
		},
		"15": {
			_label: "退款商品",
			data: [
				{ statistical_time: "2026-02-20", refund_path: "成交退款", product_id: "3777821152630669901", product_name: "手工陶瓷茶杯 复古风 大容量马克杯", sales_type: "自营", carrier_type: "全部", all_refund_ucnt: 28, all_refund_ocnt: 35, all_refund_amt: 5320.00, all_refund_rate: 7.02, all_refund_upay_amt: 45600.00, all_refund_orer_cnt: 300, ship_before_refund_ucnt: 8, ship_before_refund_ocnt: 10, ship_before_refund_amt: 1520.00, ship_before_refund_rate: 2.01, ship_after_noreceive_refund_ucnt: 6, ship_after_noreceive_refund_ocnt: 8, ship_after_noreceive_refund_amt: 1200.00, ship_after_noreceive_refund_rate: 1.58, ship_after_receive_b_refund_ocnt: 10, ship_after_receive_b_refund_amt: 1500.00, ship_after_receive_b_refund_rate: 1.98, ship_after_receive_refund_ucnt: 6, ship_after_receive_refund_ocnt: 7, ship_after_receive_refund_amt: 1100.00, ship_after_receive_refund_rate: 1.45 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", product_id: "3777821152630669902", product_name: "日式简约陶瓷碗碟套装 家用餐具", sales_type: "自营", carrier_type: "全部", all_refund_ucnt: 32, all_refund_ocnt: 40, all_refund_amt: 6800.00, all_refund_rate: 9.42, all_refund_upay_amt: 38200.00, all_refund_orer_cnt: 175, ship_before_refund_ucnt: 10, ship_before_refund_ocnt: 12, ship_before_refund_amt: 2100.00, ship_before_refund_rate: 2.91, ship_after_noreceive_refund_ucnt: 8, ship_after_noreceive_refund_ocnt: 10, ship_after_noreceive_refund_amt: 1600.00, ship_after_noreceive_refund_rate: 2.22, ship_after_receive_b_refund_ocnt: 10, ship_after_receive_b_refund_amt: 1700.00, ship_after_receive_b_refund_rate: 2.36, ship_after_receive_refund_ucnt: 6, ship_after_receive_refund_ocnt: 8, ship_after_receive_refund_amt: 1400.00, ship_after_receive_refund_rate: 1.94 },
				{ statistical_time: "2026-02-20", refund_path: "成交退款", product_id: "3777821152630669903", product_name: "创意手绘花瓶 客厅装饰摆件", sales_type: "自营", carrier_type: "全部", all_refund_ucnt: 22, all_refund_ocnt: 26, all_refund_amt: 4200.00, all_refund_rate: 9.82, all_refund_upay_amt: 28500.00, all_refund_orer_cnt: 100, ship_before_refund_ucnt: 6, ship_before_refund_ocnt: 8, ship_before_refund_amt: 1200.00, ship_before_refund_rate: 2.81, ship_after_noreceive_refund_ucnt: 5, ship_after_noreceive_refund_ocnt: 6, ship_after_noreceive_refund_amt: 900.00, ship_after_noreceive_refund_rate: 2.11, ship_after_receive_b_refund_ocnt: 6, ship_after_receive_b_refund_amt: 1100.00, ship_after_receive_b_refund_rate: 2.57, ship_after_receive_refund_ucnt: 4, ship_after_receive_refund_ocnt: 6, ship_after_receive_refund_amt: 1000.00, ship_after_receive_refund_rate: 2.34 }
			]
		}
	}
};
*/

export default {
  name: "ucShopBoardDetail",
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      currentShopId: '',
      shopOptions: [],
      currentPlatform: 1, // 当前店铺的平台类型，1=抖店，7=微信小店
      mainTab: 'transaction',
      subTab: '1',
      timeSelectId: 1,
      customDateRange: '',
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            // 当选择了开始日期但还没选择结束日期时，禁用超过31天的日期
            this.selectingStartDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          // 禁用未来日期
          if (time.getTime() > Date.now()) {
            return true;
          }
          // 如果正在选择日期范围，限制最多31天
          if (this.selectingStartDate) {
            const oneDay = 24 * 60 * 60 * 1000;
            const maxDays = 31;
            const minTime = this.selectingStartDate - maxDays * oneDay;
            const maxTime = this.selectingStartDate + maxDays * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      },
      selectingStartDate: null,
      searchData: {
        start_time: '',
        end_time: '',
      },
      timeOptions: [
        { id: 1, name: '实时', day: 'realtime' },
        { id: 2, name: '近1天', day: '1' },
        { id: 3, name: '近7天', day: '7' },
        { id: 4, name: '近30天', day: '30' },
      ],
      // 每个模块独立的筛选状态
      sectionFilters: {
        '1': { salesType: '', carrier: '', adTime: '' },  // 成交概览
        '2': { salesType: '', carrier: '', adTime: '' },  // 自营成交
        '3': { salesType: '', carrier: '', adTime: '' },  // 合作成交
        '4': { salesType: '', carrier: '', adTime: '' },  // 收支概况
        '5': { salesType: '' },  // 载体构成
        '6': { salesType: '' },  // 账号构成
        '7': {},  // 终端构成（无筛选）
        '8': {},  // 品类构成（无筛选）
        '9': { carrier: '' },  // 商品构成 - 默认为空字符串表示"全部"
        '10': {},  // 价格带构成（无筛选）
        '11': {},  // 人群构成（无筛选）
        '12': { salesType: '', carrier: '' },  // 退款整体数据
        '13': { salesType: '', carrier: '' },  // 退款构成
        '14': { salesType: '' },  // 退款原因
        '15': { salesType: '' },  // 退款商品
      },
      refundTimeType: 'pay', // 'pay' 或 'refund'
      // 数据缓存，避免重复计算
      sectionDataCache: {},
      cacheVersion: 0, // 缓存版本号，数据更新时递增
      salesTypeOptions: [
        { value: '', label: '全店' },
        { value: '自营', label: '自营' },
        { value: '合作', label: '合作' },
      ],
      carrierOptions: [
        { value: '', label: '全部' },
        { value: '直播', label: '直播' },
        { value: '短视频', label: '短视频' },
        { value: '商品卡', label: '商品卡' },
        { value: '图文', label: '图文' },
        { value: '其他', label: '其他' },
      ],
      filterChannelType: '',
      channelTypeOptions: [
        { value: '', label: '全部' },
        { value: '抖音号', label: '抖音号' },
        { value: '自然流量', label: '自然流量' },
      ],
      adTimeOptions: [
        { value: '', label: '不限' },
        { value: '全域投放时段', label: '全域投放时段' },
        { value: '标准+品牌投放', label: '标准+品牌投放' },
        { value: '非投放时段', label: '非投放时段' },
      ],
      apiData: {
        transaction_data: {},
        refund_data: {}
      },
      filterSections: filterSections,
      cardSections: cardSections,
      // 指标配置
      fieldGroups: fieldGroups,
      selectedFields: [],  // 成交概览的字段配置
      selectedFieldsType4: [],  // 收支概况的字段配置
      tempSelectedFields: [],
      showFieldConfig: false,
    }
  },
  components: { myHead, myFoot, ucMenu },
  computed: {
    // 当前显示的日期范围
    displayDateRange: {
      get() {
        // 如果有自定义日期范围，直接返回
        if (this.customDateRange && this.customDateRange.length === 2) {
          return this.customDateRange;
        }

        // 格式化日期的辅助函数
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        // 根据快捷时间标签计算日期范围
        if (this.timeSelectId) {
          const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
          if (timeOption) {
            const today = new Date();
            const endDate = formatDate(today);

            if (timeOption.day === 'realtime') {
              return [endDate, endDate];
            } else {
              const days = parseInt(timeOption.day);
              const yesterday = new Date(today);
              yesterday.setDate(yesterday.getDate() - 1);
              const end = formatDate(yesterday);
              const start = new Date(yesterday);
              start.setDate(start.getDate() - (days - 1));
              const startDate = formatDate(start);
              return [startDate, end];
            }
          }
        }

        // 默认返回今天
        const today = new Date();
        const todayStr = formatDate(today);
        return [todayStr, todayStr];
      },
      set(value) {
        // 当用户手动选择日期时，更新 customDateRange
        this.customDateRange = value;
      }
    },
    // 是否为实时数据
    isRealtimeData() {
      return this.timeSelectId === 1;
    },
    // 当前的子标签列表
    currentSubTabs() {
      const tabs = this.mainTab === 'transaction' ? transactionSubTabs : refundSubTabs;
      // 实时数据时只显示成交概览
      if (this.isRealtimeData && this.mainTab === 'transaction') {
        return tabs.filter(tab => tab.key === '1');
      }
      return tabs;
    },
    // 是否显示筛选条件
    showFilter() {
      return filterSections.includes(this.subTab);
    },
    // 是否使用卡片视图
    isCardView() {
      return cardSections.includes(this.subTab);
    },
    // 卡片视图的字段分组
    currentCardGroups() {
      if (this.subTab === '4') {
        // 处理退款构成的时间切换
        return incomeExpenseCardGroups.map(group => {
          if (group.hasTimeSwitch) {
            return {
              ...group,
              fields: this.refundTimeType === 'pay' ? group.fields : group.fieldsRefundTime
            };
          }
          return group;
        });
      }
      if (this.subTab === '5') {
        return carrierCardGroups;
      }
      // 成交概览：实时数据时只显示实时数据有的字段
      if (this.subTab === '1' && this.isRealtimeData) {
        return [
          {
            name: '交易指标',
            fields: [
              { key: 'pay_amt', label: '用户支付金额', fmt: 'money' },
              { key: 'income_amt', label: '商家实际收入', fmt: 'money' },
              { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
              { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
              { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
            ]
          },
          {
            name: '退款指标',
            fields: [
              { key: 'refund_amt', label: '退款金额', fmt: 'money' },
              { key: 'rfndsuc_amt', label: '退款额', fmt: 'money' },
              { key: 'refund_order_cnt', label: '退款订单数', fmt: 'num' },
              { key: 'refund_amt_rate', label: '退款率', fmt: 'rate' },
            ]
          },
          {
            name: '流量指标',
            fields: [
              { key: 'product_show_ucnt', label: '商品曝光人数', fmt: 'bignum' },
              { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
              { key: 'product_show_cnt', label: '商品曝光次数', fmt: 'bignum' },
              { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum' },
              { key: 'product_show_click_cnt_ratio', label: '曝光-点击转化率(次数)', fmt: 'rate' },
              { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率(次数)', fmt: 'rate' },
              { key: 'gpm', label: '千次曝光支付金额', fmt: 'money' },
            ]
          }
        ];
      }
      return overviewCardGroups;
    },
    cardData() {
      if (!this.isCardView) return {};
      let sectionData = this.getSectionData();
      if (!sectionData || sectionData.length === 0) return {};
      let filtered = sectionData;

      // 按载体类型筛选
      if (this.filterCarrier) {
        // 选择了具体载体，精确匹配
        filtered = filtered.filter(row => {
          const carrierValue = row.carrier_type || row.carrier || '';
          return carrierValue === this.filterCarrier;
        });
      }
      // 如果没有选择载体（选择"全部"），不进行筛选，显示所有数据

      // 按投放时段筛选
      if (this.filterAdTime) {
        // 选择了具体投放时段，精确匹配
        filtered = filtered.filter(row => {
          const adTimeValue = row.qc_ad_time || '';
          return adTimeValue === this.filterAdTime;
        });
      }
      // 如果没有选择投放时段（选择"不限"），不进行筛选，显示所有数据

      return filtered.length > 0 ? filtered[0] : {};
    },
    // 表格数据：收支概况需要按筛选条件过滤
    tableData() {
      if (this.isCardView) return [];
      let sectionData = this.getSectionData();
      if (!sectionData) return [];
      // 收支概况需要按载体和投放时段筛选
      if (this.subTab === '4') {
        let filtered = sectionData;

        // 按载体类型筛选
        if (this.filterCarrier) {
          // 选择了具体载体，精确匹配
          filtered = filtered.filter(row => {
            const carrierValue = row.carrier_type || row.carrier || '';
            return carrierValue === this.filterCarrier;
          });
        }
        // 如果没有选择载体（选择"全部"），不进行筛选，显示所有数据

        // 按投放时段筛选
        if (this.filterAdTime) {
          // 选择了具体投放时段，精确匹配
          filtered = filtered.filter(row => {
            const adTimeValue = row.qc_ad_time || '';
            return adTimeValue === this.filterAdTime;
          });
        }
        // 如果没有选择投放时段（选择"不限"），不进行筛选，显示所有数据

        return filtered;
      }
      return sectionData;
    },
    // 表格列定义（根据用户选择的字段过滤）
    currentTableColumns() {
      return tableColumnMap[this.subTab] || [];
    },
  },
  watch: {
    mainTab() {
      // 切换一级标签时，重置到对应的第一个子标签
      this.subTab = this.currentSubTabs[0].key;
      this.filterCarrier = '';
      // 清空缓存
      this.sectionDataCache = {};
    },
    subTab(val) {
      // 切换子标签时清空缓存
      this.sectionDataCache = {};
    },
    // 监听时间选择变化，清空缓存和数据
    timeSelectId() {
      this.sectionDataCache = {};
      // 强制清空 apiData，确保不会显示旧数据
      this.apiData = {
        transaction_data: {},
        refund_data: {}
      };
    },
    // 监听筛选条件变化，清空缓存
    sectionFilters: {
      handler() {
        this.sectionDataCache = {};
      },
      deep: true
    },
    refundTimeType() {
      this.sectionDataCache = {};
    }
  },
  created() {
    // 从路由参数获取店铺ID
    this.currentShopId = this.$route.query.id ? parseInt(this.$route.query.id) : '';
    this.loadShopList();
    this.loadData();
    this.loadFieldConfig();

    // 创建防抖函数用于筛选变化
    this.debouncedClearCache = this.debounce(() => {
      this.sectionDataCache = {};
    }, 150);
  },
  beforeDestroy() {
    // 清理工作（如果需要）
  },
  methods: {
    ...mapActions({
      getShopDataDetail: "shop_board/getShopDataDetail",
      getShopList: "shop_board/getShopList",
    }),
    // 获取指定section支持的筛选类型
    getSectionFilters(key) {
      // 实时数据时，成交概览不显示筛选
      if (this.isRealtimeData && key === '1') {
        return [];
      }
      return sectionFilterConfig[key] || [];
    },
    // 获取指定section的售卖类型选项
    getSalesTypeOptions(key) {
      if (key === '5') {
        return [
          { value: '自营', label: '自营' },
          { value: '带货', label: '带货' },
        ];
      }
      return this.salesTypeOptions;
    },
    getCardGroups(key) {
      let groups;
      if (key === '4') {
        groups = incomeExpenseCardGroups.map(group => {
          if (group.hasTimeSwitch) {
            return {
              ...group,
              fields: this.refundTimeType === 'pay' ? group.fields : group.fieldsRefundTime
            };
          }
          return group;
        });
        console.log('[getCardGroups] type4 原始分组:', groups);
        console.log('[getCardGroups] selectedFieldsType4:', this.selectedFieldsType4);

        // 收支概况使用独立的字段配置
        if (this.selectedFieldsType4 && this.selectedFieldsType4.length > 0) {
          console.log('[getCardGroups] 应用type4字段筛选');
          const filtered = groups.map(group => {
            return {
              ...group,
              fields: group.fields.filter(f => this.selectedFieldsType4.includes(f.key))
            };
          }).filter(group => group.fields.length > 0);
          console.log('[getCardGroups] type4筛选后的分组:', filtered);
          return filtered;
        }
        return groups;
      } else if (key === '5') {
        groups = carrierCardGroups;
      } else if (key === '1' && this.isRealtimeData) {
        // 实时数据的成交概览：使用简化的字段分组
        groups = [
          {
            name: '交易指标',
            fields: [
              { key: 'pay_amt', label: '用户支付金额', fmt: 'money' },
              { key: 'income_amt', label: '商家实际收入', fmt: 'money' },
              { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
              { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
              { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
            ]
          },
          {
            name: '退款指标',
            fields: [
              { key: 'refund_amt', label: '退款金额', fmt: 'money' },
              { key: 'rfndsuc_amt', label: '退款额', fmt: 'money' },
              { key: 'refund_order_cnt', label: '退款订单数', fmt: 'num' },
              { key: 'refund_amt_rate', label: '退款率', fmt: 'rate' },
            ]
          },
          {
            name: '流量指标',
            fields: [
              { key: 'product_show_ucnt', label: '商品曝光人数', fmt: 'bignum' },
              { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
              { key: 'product_show_cnt', label: '商品曝光次数', fmt: 'bignum' },
              { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum' },
              { key: 'product_show_click_cnt_ratio', label: '曝光-点击转化率(次数)', fmt: 'rate' },
              { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率(次数)', fmt: 'rate' },
              { key: 'gpm', label: '千次曝光支付金额', fmt: 'money' },
            ]
          }
        ];
      } else {
        groups = overviewCardGroups;
      }

      // 只对成交概览(1)应用字段筛选
      if (key === '1' && this.selectedFields && this.selectedFields.length > 0) {
        console.log('[getCardGroups] 应用字段筛选, key:', key, 'selectedFields:', this.selectedFields);
        const filtered = groups.map(group => {
          return {
            ...group,
            fields: group.fields.filter(f => this.selectedFields.includes(f.key))
          };
        }).filter(group => group.fields.length > 0);
        console.log('[getCardGroups] 筛选后的分组:', filtered);
        return filtered;
      }
      return groups;
    },
    // 获取当前 tab 的标签文本
    getCurrentTabLabel() {
      const tab = this.currentSubTabs.find(t => t.key === this.subTab);
      return tab ? tab.label : '';
    },
    goBack() {
      // 使用浏览器返回，保持菜单状态
      this.$router.go(-1);
    },
    // 切换一级标签
    switchMainTab(tab) {
      this.mainTab = tab;
    },
    // 时间快捷标签点击
    timeTagClick(item) {
      this.timeSelectId = item.id;
      this.customDateRange = '';
      this.searchData.start_time = '';
      this.searchData.end_time = '';

      // 切换到实时数据时，确保在成交数据tab且子tab为成交概览
      if (item.id === 1) {
        this.mainTab = 'transaction';
        this.subTab = '1';
      }

      // 强制清空缓存和数据，确保重新渲染
      this.sectionDataCache = {};
      this.apiData = {
        transaction_data: {},
        refund_data: {}
      };

      this.loadData();
    },
    // 自定义日期变更
    customDateChange() {
      // 重置选择状态
      this.selectingStartDate = null;

      if (this.customDateRange && this.customDateRange.length === 2) {
        // 验证日期范围不超过31天
        const start = new Date(this.customDateRange[0]);
        const end = new Date(this.customDateRange[1]);
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
          this.$message.warning('时间范围不能超过31天');
          this.customDateRange = '';
          return;
        }

        this.timeSelectId = '';
        this.searchData.start_time = this.customDateRange[0];
        this.searchData.end_time = this.customDateRange[1];
      } else {
        this.timeSelectId = 1;
        this.customDateRange = '';
        this.searchData.start_time = '';
        this.searchData.end_time = '';
      }

      // 强制清空缓存和数据，确保重新渲染
      this.sectionDataCache = {};
      this.apiData = {
        transaction_data: {},
        refund_data: {}
      };

      this.loadData();
    },
    // 获取当前 section 的原始数据
    // 获取当前 section 的原始数据
    // 获取当前 section 的原始数据
    getSectionData() {
      let source = this.mainTab === 'transaction' ? this.apiData.transaction_data : this.apiData.refund_data;
      let sectionKey = this.subTab;
      if (!source || !source[sectionKey]) return [];
      let data = source[sectionKey].data || [];

      // 获取当前模块的筛选状态
      const filters = this.sectionFilters[sectionKey] || {};

      // 根据售卖类型筛选
      if (filters.salesType && data.length > 0) {
        data = data.filter(row => row.sales_type === filters.salesType);
      }

      // 根据载体筛选
      if (filters.carrier && data.length > 0) {
        data = data.filter(row => row.carrier_type === filters.carrier);
      }

      // 根据渠道筛选
      if (filters.channelType && data.length > 0) {
        data = data.filter(row => row.channel_type === filters.channelType);
      }

      // 根据投放时段筛选
      if (filters.adTime && data.length > 0) {
        data = data.filter(row => row.qc_ad_time === filters.adTime);
      }

      return data;
    },
    // 加载数据
    loadData() {
      if (!this.currentShopId) return;

      this.loading = true;
      // 清空缓存
      this.sectionDataCache = {};
      this.cacheVersion++;

      // 构建请求参数
      let params = {
        mer_shop_id: this.currentShopId,
      };

      // 自定义日期范围
      if (this.searchData.start_time && this.searchData.end_time) {
        params.start_date = this.searchData.start_time;
        params.end_date = this.searchData.end_time;
      } else {
        // 根据时间类型计算日期范围
        const today = new Date();
        const endDate = this.formatDate(today);
        let startDate = endDate;

        if (this.timeSelectId) {
          const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
          if (timeOption && timeOption.day !== 'realtime') {
            const days = parseInt(timeOption.day);
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const end = this.formatDate(yesterday);
            const start = new Date(yesterday);
            start.setDate(start.getDate() - (days - 1));
            startDate = this.formatDate(start);
            params.start_date = startDate;
            params.end_date = end;
          } else {
            // 实时数据
            params.start_date = endDate;
            params.end_date = endDate;
            params.is_realtime = 1;
          }
        } else {
          params.start_date = endDate;
          params.end_date = endDate;
        }
      }

      this.getShopDataDetail({
        data: params,
        success: (res) => {
          this.loading = false;
          if (res.code === 200) {
            // 无论数据是否为空，都要更新 apiData，确保切换时清空旧数据
            this.apiData = res.data || { transaction_data: {}, refund_data: {} };
            console.log('[loadData] 接口返回数据:', res.data);
            console.log('[loadData] transaction_data keys:', Object.keys(this.apiData.transaction_data || {}));
            console.log('[loadData] refund_data keys:', Object.keys(this.apiData.refund_data || {}));
          } else {
            this.$message.error(res.msg || '获取数据失败');
          }
        }
      });
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 加载店铺列表
    loadShopList() {
      this.getShopList({
        data: { shop_type: 1,status:1},
        success: (res) => {
          if (res.code === 200 && res.data) {
            // 数据结构是 data.list.list
            if (res.data.list && res.data.list.list) {
              this.shopOptions = res.data.list.list;
            } else if (Array.isArray(res.data.list)) {
              this.shopOptions = res.data.list;
            } else if (Array.isArray(res.data)) {
              this.shopOptions = res.data;
            } else {
              this.shopOptions = [];
            }
          }
        }
      });
    },
    // 切换店铺
    handleShopChange(shopId) {
      // 更新路由参数
      const selectedShop = this.shopOptions.find(shop => shop.shop_id === shopId);
      this.$router.replace({
        path: '/uc_shop_board_detail',
        query: {
          id: shopId,
          shop_name: selectedShop ? selectedShop.shop_name : ''
        }
      });
      // 重新加载数据
      this.loadData();
    },
    getFieldValue(row, field) {
      if (!row || !field) return undefined;
      if (field.sourceKey) {
        return row[field.sourceKey];
      }
      return row[field.key];
    },
    // 格式化数值
    formatValue(field, val) {
      if (val === undefined || val === null || val === '') return '--';

      // 商品ID特殊处理，确保作为字符串显示
      if (field.key === 'product_id') {
        return String(val);
      }

      if (field.fmt === 'text') return val;
      if (field.fmt === 'money') {
        let n = Number(val);
        if (isNaN(n)) return val;
        if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万';
        return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      if (field.fmt === 'num') {
        let n = Number(val);
        if (isNaN(n)) return val;
        if (n >= 10000) return (n / 10000).toFixed(2) + '万';
        return n.toLocaleString('zh-CN');
      }
      if (field.fmt === 'bignum') {
        let n = Number(val);
        if (isNaN(n)) return val;
        if (n >= 10000) return (n / 10000).toFixed(1) + '万';
        return n.toLocaleString('zh-CN');
      }
      if (field.fmt === 'rate') {
        let n = Number(val);
        if (isNaN(n)) return val;
        return n.toFixed(2) + '%';
      }
      return val;
    },
    // 值的样式类
    getValueClass(field, val) {
      if (field.fmt === 'rate') {
        let n = parseFloat(val);
        if (!isNaN(n)) {
          if (n >= 10) return 'val_rate val_rate_high';
          if (n >= 5) return 'val_rate val_rate_mid';
        }
        return 'val_rate';
      }
      if (field.fmt === 'money') return 'val_money';
      return '';
    },
    // 获取指定section的卡片数据（带缓存优化）
    getSectionCardData(key) {
      // 生成缓存键，包含 timeSelectId 确保实时/历史数据切换时缓存失效
      const cacheKey = `card_${key}_${this.mainTab}_${this.timeSelectId}_${this.cacheVersion}_${JSON.stringify(this.sectionFilters[key] || {})}_${this.refundTimeType}`;

      // 检查缓存
      if (this.sectionDataCache[cacheKey]) {
        return this.sectionDataCache[cacheKey];
      }

      let source = this.mainTab === 'transaction' ? this.apiData.transaction_data : this.apiData.refund_data;
      let sectionKey = key;

      // 获取当前section的筛选条件
      const filters = this.sectionFilters[key] || {};
      const filterSalesType = filters.salesType || '';
      const filterCarrier = filters.carrier || '';
      const filterAdTime = filters.adTime || '';

      // 成交概览(1)：售卖类型决定读取哪个key的数据
      if (key === '1') {
        if (filterSalesType === '自营') {
          sectionKey = '2';
        } else if (filterSalesType === '合作') {
          sectionKey = '3';
        }
        // 全部或空值时使用key=1
      }

      if (!source || !source[sectionKey]) {
        console.log(`[getSectionCardData] 数据源为空, key=${key}, sectionKey=${sectionKey}`);
        return {};
      }

      // 接口返回的数据结构：source[sectionKey] 直接就是数组
      let sectionData = Array.isArray(source[sectionKey]) ? source[sectionKey] : (source[sectionKey].data || []);

      if (sectionData.length === 0) {
        console.log(`[getSectionCardData] 数据为空, key=${key}, sectionKey=${sectionKey}`);
        return {};
      }

      if (key === '4') {
        console.log(`[getSectionCardData] type4 原始数据:`, sectionData);
        console.log(`[getSectionCardData] type4 筛选条件:`, filters);
      }

      // 只对成交概览(1)和收支概况(4)应用筛选
      if (key === '1' || key === '4') {
        let filtered = sectionData;

        // 收支概况(4)需要按售卖类型筛选
        if (key === '4' && filterSalesType) {
          filtered = filtered.filter(row => {
            return row.sales_type === filterSalesType;
          });
          console.log(`[getSectionCardData] type4 按售卖类型筛选后:`, filtered);
        }

        // 按载体类型筛选
        if (filterCarrier) {
          filtered = filtered.filter(row => {
            const carrierValue = row.carrier_type || row.carrier || '';
            return carrierValue === filterCarrier;
          });
          console.log(`[getSectionCardData] type4 按载体筛选后:`, filtered);
        }

        // 按投放时段筛选
        if (filterAdTime) {
          filtered = filtered.filter(row => {
            const adTimeValue = row.qc_ad_time || '';
            return adTimeValue === filterAdTime;
          });
          console.log(`[getSectionCardData] type4 按投放时段筛选后:`, filtered);
        }

        const result = filtered.length > 0 ? filtered[0] : {};
        if (key === '4') {
          console.log(`[getSectionCardData] type4 最终结果:`, result);
        }
        // 缓存结果
        this.sectionDataCache[cacheKey] = result;
        return result;
      }

      // 载体构成(5)需要聚合数据
      if (key === '5') {
        let filtered = sectionData;
        // 按售卖类型筛选（自营/带货）
        if (filterSalesType) {
          filtered = filtered.filter(row => row.sales_type === filterSalesType);
        }

        const aggregated = {};
        // 按销售类型聚合
        aggregated.self_pay_amt = filtered.filter(row => row.sales_type === '自营').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        aggregated.coop_pay_amt = filtered.filter(row => row.sales_type === '带货').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        // 按载体类型聚合
        aggregated.live_pay_amt = filtered.filter(row => row.carrier_type === '直播').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        aggregated.video_pay_amt = filtered.filter(row => row.carrier_type === '短视频').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        aggregated.graphic_pay_amt = filtered.filter(row => row.carrier_type === '图文').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        aggregated.card_pay_amt = filtered.filter(row => row.carrier_type === '商品卡').reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);
        aggregated.other_pay_amt = filtered.filter(row => !['直播', '短视频', '图文', '商品卡'].includes(row.carrier_type)).reduce((sum, row) => sum + (Number(row.pay_amt) || 0), 0);

        // 缓存结果
        this.sectionDataCache[cacheKey] = aggregated;
        return aggregated;
      }

      // 其他section直接返回第一条数据
      const result = sectionData[0] || {};
      // 缓存结果
      this.sectionDataCache[cacheKey] = result;
      return result;
    },
    // 获取指定section的表格数据（带缓存优化）
    getSectionTableData(key) {
      // 生成缓存键，包含 timeSelectId 确保实时/历史数据切换时缓存失效
      const cacheKey = `table_${key}_${this.mainTab}_${this.timeSelectId}_${this.cacheVersion}_${JSON.stringify(this.sectionFilters[key] || {})}`;

      // 检查缓存
      if (this.sectionDataCache[cacheKey]) {
        return this.sectionDataCache[cacheKey];
      }

      let source = this.mainTab === 'transaction' ? this.apiData.transaction_data : this.apiData.refund_data;
      let sectionKey = key;

      // 获取当前section的筛选条件
      const sectionFilter = this.sectionFilters[key] || {};
      const filterSalesType = sectionFilter.salesType || '';
      const filterCarrier = sectionFilter.carrier || '';
      const filterAdTime = sectionFilter.adTime || '';
      const filterChannelType = sectionFilter.channelType || '';

      // 成交概览(1)：售卖类型决定读取哪个key的数据
      if (key === '1') {
        if (filterSalesType === '自营') {
          sectionKey = '2';
        } else if (filterSalesType === '合作') {
          sectionKey = '3';
        }
        // 全部或空值时使用key=1
      }

      if (!source || !source[sectionKey]) return [];

      // 接口返回的数据结构：source[sectionKey] 直接就是数组
      let sectionData = Array.isArray(source[sectionKey]) ? source[sectionKey] : (source[sectionKey].data || []);

      // 根据section筛选配置应用过滤
      const filters = sectionFilterConfig[key];
      if (filters) {
        let filtered = sectionData;

        // 按售卖类型筛选（成交概览(1)通过切换数据源实现，不在此过滤）
        if (filters.includes('salesType') && key !== '1' && filterSalesType) {
          filtered = filtered.filter(row => row.sales_type === filterSalesType);
        }

        // 按载体类型筛选
        if (filters.includes('carrier') && filterCarrier) {
          // 空字符串就是“全部”，不做过滤；选择具体载体时才精确匹配
          filtered = filtered.filter(row => {
            const carrierValue = row.carrier_type || row.product_carrier || row.carrier || '';
            return carrierValue === filterCarrier;
          });
        }

        // 按投放时段筛选
        if (filters.includes('adTime') && filterAdTime) {
          filtered = filtered.filter(row => (row.qc_ad_time || '') === filterAdTime);
        }

        // 按渠道筛选
        if (filters.includes('channelType') && filterChannelType) {
          filtered = filtered.filter(row => (row.channel_type || '') === filterChannelType);
        }

        // 缓存结果
        this.sectionDataCache[cacheKey] = filtered;
        return filtered;
      }

      // 缓存结果
      this.sectionDataCache[cacheKey] = sectionData;
      return sectionData;
    },
    // 获取指定section的表格列定义
    getTableColumns(key) {
      return tableColumnMap[key] || [];
    },
    // 切换到指定section
    scrollToSection(key) {
      this.subTab = key;
    },
    // 监听滚动，自动选中对应的tab（优化版本）
    handleScroll() {
      // 如果正在程序化滚动或正在更新tab，不处理
      if (this.isScrolling || this.isUpdatingTab) return;

      // 节流处理，避免频繁触发（增加到200ms）
      if (this.scrollTimer) return;

      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;

        const dataContent = this.$refs.dataContent;
        if (!dataContent) return;

        const scrollTop = dataContent.scrollTop;
        const containerTop = dataContent.offsetTop;
        const viewportHeight = dataContent.clientHeight;

        // 缓存section位置信息，避免重复计算
        const sectionPositions = this.currentSubTabs.map(tab => {
          const sectionRefs = this.$refs['section-' + tab.key];
          if (sectionRefs && sectionRefs.length > 0) {
            const sectionEl = sectionRefs[0];
            return {
              key: tab.key,
              top: sectionEl.offsetTop - containerTop,
              height: sectionEl.offsetHeight
            };
          }
          return null;
        }).filter(Boolean);

        // 找到当前可见的section（从后往前遍历，找到第一个顶部在视口内的）
        for (let i = sectionPositions.length - 1; i >= 0; i--) {
          const section = sectionPositions[i];
          // 如果滚动位置超过了这个section的顶部（留50px缓冲区）
          if (scrollTop >= section.top - 50) {
            if (this.subTab !== section.key) {
              this.isUpdatingTab = true;
              this.subTab = section.key;
              // 使用requestAnimationFrame优化DOM更新
              this.$nextTick(() => {
                requestAnimationFrame(() => {
                  this.isUpdatingTab = false;
                });
              });
            }
            break;
          }
        }
      }, 200); // 增加节流时间到200ms
    },
    // 加载指标配置（从 localStorage）
    loadFieldConfig() {
      let saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        try {
          let parsed = JSON.parse(saved);
          if (parsed && parsed.length > 0) {
            this.selectedFields = parsed;
          } else {
            this.selectedFields = [...defaultSelectedFields];
          }
        } catch (e) {
          this.selectedFields = [...defaultSelectedFields];
        }
      } else {
        this.selectedFields = [...defaultSelectedFields];
      }
      this.tempSelectedFields = [...this.selectedFields];
    },
    // 确认指标配置
    confirmFieldConfig() {
      this.selectedFields = [...this.tempSelectedFields];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedFields));
      this.showFieldConfig = false;
    },
    // 弹窗关闭时重置临时选择
    onConfigClose() {
      this.tempSelectedFields = [...this.selectedFields];
    },
    // 获取分组已选数量
    getGroupCheckedCount(group) {
      return group.fields.filter(f => this.tempSelectedFields.includes(f.key)).length;
    },
    // 分组是否全选
    isGroupAllChecked(group) {
      return group.fields.every(f => this.tempSelectedFields.includes(f.key));
    },
    // 分组是否半选
    isGroupIndeterminate(group) {
      let count = this.getGroupCheckedCount(group);
      return count > 0 && count < group.fields.length;
    },
    // 切换分组全选/取消
    toggleGroupAll(group, checked) {
      let keys = group.fields.map(f => f.key);
      if (checked) {
        let set = new Set(this.tempSelectedFields);
        keys.forEach(k => set.add(k));
        this.tempSelectedFields = [...set];
      } else {
        this.tempSelectedFields = this.tempSelectedFields.filter(k => !keys.includes(k));
      }
    },
    // 防抖工具函数
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    // 初始化 Intersection Observer 用于懒加载
    initIntersectionObserver() {
      // 等待 DOM 渲染完成
      this.$nextTick(() => {
        // 如果已存在，先断开
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        const dataContent = this.$refs.dataContent;
        if (!dataContent) {
          console.warn('dataContent ref not found');
          return;
        }

        const options = {
          root: dataContent,
          rootMargin: '200px', // 提前200px开始加载
          threshold: 0.01
        };

        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // 从 data-section-key 属性中提取 section key
            const sectionKey = entry.target.getAttribute('data-section-key');
            if (sectionKey && entry.isIntersecting) {
              // section 进入可视区域，标记为可见
              if (!this.visibleSections.includes(sectionKey)) {
                this.visibleSections.push(sectionKey);
              }
            }
          });
        }, options);

        // 观察所有 section
        this.currentSubTabs.forEach(tab => {
          const sectionRefs = this.$refs['section-' + tab.key];
          if (sectionRefs && sectionRefs.length > 0) {
            const sectionEl = sectionRefs[0];
            this.intersectionObserver.observe(sectionEl);
          }
        });
      });
    },
    // 检查 section 是否应该渲染数据
    shouldRenderSection(key) {
      // 使用数组的 includes 方法
      return this.visibleSections.includes(key);
    },
  }
}
</script>

<style scoped>

.center{display: flex;flex: 1;}
.wrap--embedded{min-width:0;min-height:0;background:transparent;}
.wrap--embedded .wrap_body{padding:0;}
.wrap--embedded .center{width:100%;min-width:0;margin:0;}
.wrap--embedded .ucenter_main{padding:0;gap:0;}
.wrap--embedded .right_con{width:100%;background:transparent;}

.el-card__body{padding:12px 20px;}

/* 页面头部 */
.page_header{display: flex;align-items: center;padding-bottom: 12px;border-bottom: 1px solid #EBEEF5;}
.back_btn{font-size: 14px;color: #409EFF;cursor: pointer;display: flex;align-items: center;}
.back_btn:hover{color: #66b1ff;}
.back_btn i{margin-right: 2px;font-size: 16px;}
.page_title{font-size: 18px;font-weight: bold;color: #303133;margin-left: 12px;}
.shop_selector{margin-left: auto;display: flex;align-items: center;}
.shop_selector .filter_label{font-size: 14px;color: #606266;margin-right: 8px;}

/* 一级标签 */
.main_tabs{display: flex;margin-top: 16px;border-bottom: 2px solid #EBEEF5;}
.main_tab{padding: 8px 24px;font-size: 15px;color: #606266;cursor: pointer;position: relative;font-weight: 500;transition: color 0.2s;}
.main_tab:hover{color: #409EFF;}
.main_tab.active{color: #409EFF;}
.main_tab.active::after{content: '';position: absolute;bottom: -2px;left: 0;right: 0;height: 2px;background: #409EFF;}

/* 二级标签 */
.sub_tabs{display: flex;flex-wrap: wrap;gap: 0;margin-top: 12px;padding-bottom: 8px;border-bottom: 1px solid #EBEEF5;}
.sub_tab{padding: 6px 16px;font-size: 13px;color: #737E97;cursor: pointer;border-radius: 4px;transition: all 0.2s;white-space: nowrap;}
.sub_tab:hover{color: #409EFF;background: #ecf5ff;}
.sub_tab.active{color: #fff;background: #409EFF;}

/* 筛选栏 */
.filter_bar{display: flex;align-items: center;flex-wrap: wrap;padding: 12px 0;gap: 16px;}
.filter_bar.sub_filter{padding: 4px 0 12px;border-bottom: 1px solid #EBEEF5;margin-bottom: 4px;}

/* 时间快捷标签 */
.time_tag{display: inline-block;padding: 4px 10px;font-size: 13px;color: #737E97;cursor: pointer;border-radius: 4px;margin-right: 4px;transition: all 0.2s;}
.time_tag:hover{color: #409EFF;}
.time_tag.active{color: #fff;background: #409EFF;}
.filter_item{display: flex;align-items: center;}
.filter_label{font-size: 13px;color: #606266;white-space: nowrap;margin-right: 4px;}

/* 数据内容区域 */
.data_content{
  min-height: 300px;
  padding-top: 5px;
}

/* 数据section - 优化渲染性能 */
.data_section{
  margin-bottom: 30px;
  padding-bottom: 20px;
  /* 使用 contain 优化渲染 */
  contain: layout style paint;
}
.section_title{font-size: 15px;font-weight: bold;color: #303133;padding: 10px 0;margin-bottom: 12px;border-left: 4px solid #409EFF;padding-left: 12px;background: #f5f7fa;margin-left: -10px;padding-left: 22px;}

/* 卡片分组标题 */
.card_section{margin-bottom: 20px;}
.card_section:last-child{margin-bottom: 0;}
.card_section_title{font-size: 14px;font-weight: bold;color: #303133;padding: 8px 0;margin-bottom: 8px;border-left: 3px solid #409EFF;padding-left: 10px;}

/* 数据卡片网格 */
.data_cards{display: grid;grid-template-columns: repeat(5, 1fr);gap: 12px;}
.data_card{background: #fafbfc;border: 1px solid #ebeef5;border-radius: 6px;padding: 14px 16px;transition: box-shadow 0.2s;}
.data_card:hover{box-shadow: 0 2px 8px rgba(0,0,0,0.08);border-color: #d0d7de;}
.card_label{font-size: 12px;color: #909399;margin-bottom: 8px;line-height: 1.3;}
.card_value{font-size: 18px;font-weight: bold;color: #303133;word-break: break-all;}
.card_value.val_money{color: #303133;}
.card_value.val_rate{color: #606266;}
.card_value.val_rate_mid{color: #e6a23c;}
.card_value.val_rate_high{color: #f56c6c;}

/* 表格内文字样式 */
.val_money{color: #303133;}
.val_rate{color: #606266;}
.val_rate_mid{color: #e6a23c;font-weight: 500;}
.val_rate_high{color: #f56c6c;font-weight: bold;}

:deep(.el-table th.el-table__cell>.cell){
  padding: 0 5px !important;
}
:deep(.el-table td.el-table__cell>.cell){
  padding: 0 6px !important;
  font-size: 13px;
}

/* 收支概况卡片样式 */
.card_section_header{display: flex;justify-content: space-between;align-items: center;margin-bottom: 12px;}
.time_switch{display: flex;align-items: center;}
.income_expense_cards{display: flex;align-items: center;gap: 8px;flex-wrap: wrap;}
.income_expense_card{flex: 0 0 auto;min-width: 160px;background: #fafbfc;border: 1px solid #ebeef5;border-radius: 6px;padding: 12px 14px;}
.operator{font-size: 20px;font-weight: bold;color: #909399;padding: 0 4px;}
.card_comparison{margin-top: 8px;display: flex;flex-direction: column;gap: 4px;}
.comparison_item{display: flex;justify-content: space-between;align-items: center;font-size: 11px;}
.comparison_label{color: #909399;}
.comparison_value{color: #606266;font-weight: 500;}
.comparison_value.positive{color: #67c23a;}
.comparison_value.negative{color: #f56c6c;}

/* 指标配置标签 */
.sub_tabs .sub_tab.config-btn{background: #f0f2f5;border: 1px solid #dcdfe6;color: #606266;font-size: 12px;padding: 4px 10px;margin-left: 8px;}
.sub_tabs .sub_tab.config-btn:hover{background: #e6e8eb;color: #409EFF;}

/* 指标配置弹窗样式 */
.field_config_body{max-height: 500px;overflow-y: auto;padding: 10px 5px;}
.field_config_body .field_group{margin-bottom: 16px;padding: 10px 12px;background: #f5f7fa;border-radius: 6px;}
.field_config_body .group_title{display: flex;align-items: center;justify-content: space-between;margin-bottom: 10px;font-size: 14px;font-weight: 500;color: #606266;}
.field_config_body .group_count{font-size: 12px;color: #909399;font-weight: normal;}
.field_config_body .el-checkbox-group{display: flex;flex-wrap: wrap;gap: 8px 16px;}
.field_config_body .el-checkbox{margin-right: 0;margin-bottom: 2px;}
</style>
